import React, { useContext, useEffect, useRef, useState } from "react";
import $, { data, error } from "jquery";

import { useTranslation } from "react-i18next";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Select from "react-select";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";

import moment from "moment";

import Swal from "sweetalert2";

import OrgContext from "../../organisation/OrgContext";
import { API, baseURL, host } from "../../services/api";
import { useNavigate } from "react-router-dom";

import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import NewInvoice from "../invoice/NewInvoice";
import { Steps, Panel, Placeholder, ButtonGroup, Button } from "rsuite";
import NewClient from "../Items/NewClient";
import Client from "../../components/Client";
import NewItems from "../Items/NewItems";
import AuthContext from "../../components/shared/AuthContext";
import { toast, ToastContainer } from "react-toastify";
import { getEcEco } from "../../helpers/EcritureComptableHeper";
import NewPiece from "../piece/NewPiece";
import { frFR, enUS } from "@mui/x-data-grid";
import { LinearProgress } from "@mui/material";
import { formatNumber, isNumeric } from "../../helpers/formater";

import MobileScreen from "../../assets/images/mobile/screens/screen1.png";
import PagePDF from "./PagePDF";
import useAuthHelper from "../../helpers/AuthHelper";
import { set } from "date-fns";
import { id } from "date-fns/locale";

//import { fromPath } from "pdf2pic";

function DraftInvoicesList(props) {
  const [t, i18n] = useTranslation();

  const { user, logout } = useContext(AuthContext);

  const { organisation } = useContext(OrgContext);
  const [invoiceStatusCreatedAt, setInvoiceStatusCreatedAt] = useState("");

  const [invoices, setInvoices] = useState([]);

  const [img_preview, setPreviewImg] = useState(null);

  const [invoice, setInvoice] = useState(null);

  const [dataProcessing, setDataProcessing] = useState(null);

  const [processingLoad, setProcessingLoad] = useState(false);

  const [ice, setIce] = useState(null);

  const [invoiceDate, setInvoiceDate] = useState(null);

  const [invoiceDueDate, setInvoiceDueDate] = useState(null);

  const [subtotal, setSubtotal] = useState(null);

  const [total, setTotal] = useState(null);

  const [tva, setTva] = useState(null);

  const navigate = useNavigate();

  const [errors, setErrors] = useState([]);

  const [step, setStep] = React.useState(0);

  const [client, setClient] = useState(null);
  const [products, setProducts] = useState([]);
  const [selectProduct, setSelectedProduct] = useState({ id: 0 });
  const [invoice_products, setInvoiceProducts] = useState([]);

  const [statuses, setStatuses] = useState([]);

  const [purchaseAccounts, setPurchaseAccounts] = useState([]);
  const [taxes, setTaxes] = useState([]);

  //ec
  const [loading, setLoading] = useState(0);
  const [fluxEco, setFluxEco] = useState([]);
  const [invoiceId, setInvoiceId] = useState(0);
  const [invoiceType, setInvoiceType] = useState("");
  const [loadingData, setLoadingData] = useState(false);

  // sous compte comptable des paiement
  const [sousCompte, setSousCompte] = useState("");
  const [sousCompteCs, setSousCompteCs] = useState("");
  const [sousComptes, setSousComptes] = useState([]);
  const [sousComptesCs, setSousComptesCs] = useState([]);
  const [isService, setIsService] = useState(false);
  // invoice number
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [autoIncrementInvoiceNumber, setAutoIncrementInvoiceNumber] =
    useState(false);
  const [invoicesNums, setInvoicesNums] = useState([]);
  const [numExist, setExitNum] = useState(false);
  const [nbInvoices, setNbInvoices] = useState(0);
  const [prixUn, setPrixUn] = useState(0);
  const [qty, setQty] = useState(1);
  const [totalHT, setTotalHT] = useState(0);
  const [totalTTC, setTotalTTC] = useState(0);
  //isSauvgraded
  const [isSauvgarded, setIsSauvguarded] = useState(false);
  const [loadingSa, setLoadingSa] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [productEdit, setProductEdit] = useState();
  const { onlyMembres } = useAuthHelper();
  const [suppliers, setSuppliers] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState([]);
  const [clients, setClients] = useState([]);
  useEffect(() => {
    if (user) {
      onlyMembres();
    }
  }, [user]);

  const getNbsInvoices = async () => {
    let resp = await jwtInterceoptor.get(
      `/data/nb-factures/factures-achat/${organisation?.id}`
    );
    if (resp.status == 200) {
      let data = resp.data;
      console.log("Nbr factures", resp.data);
      if (data?.status) {
        setNbInvoices(data?.nb_factures);
        setInvoicesNums(data.data);
      }
    }
  };
  const onChange = (nextStep) => {
    setStep(nextStep < 0 ? 0 : nextStep > 3 ? 3 : nextStep);
  };
  const transformArrayToOptions = (target) => {
    let array = [];
    for (let i = 0; i < target.length; i++) {
      let obj = {
        value: target[i].id,
        label: target[i].companyName + " - " + target[i].account.code,
        id: target[i].id,
        ice: target[i].ice,
      };
      array.push(obj);
    }
    return array;
  };
  const getSuppliers = async () => {
    const response = await jwtInterceoptor
      .get(
        baseURL + `/client/getbyuser/${user.id}/fournisseurs/${organisation.id}`
      )
      .then((response) => {
        setSuppliers(transformArrayToOptions(response.data.data));
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error)
      );
  };
  const transformClientsArray = (clients) => {
    let array = [];
    for (let i = 0; i < clients.length; i++) {
      let obj = {
        value: clients[i].id,
        label: clients[i].companyName + " - " + clients[i].account.code,
        id: clients[i].id,
        ice: clients[i].ice,
      };
      array.push(obj);
    }
    return array;
  };
  const getAllAssociatedClients = async () => {
    const response = await jwtInterceoptor
      .get(baseURL + `/client/getbyuser/${user.id}/client/${organisation.id}`)
      .then((response) => {
        if (response.data.data.length === 0) {
          $("#warning-create-client-first").css("display", "block");
        } else {
          $("#warning-create-client-first").css("display", "none");
          setClients(transformClientsArray(response.data.data));
          console.log("lcintes : ", clients);
          /**
           * {
           *     "value": 56,
           *     "label": "Commodi minus omnis Ipsum ullam architec"
           * }
           */
        }
      })
      .catch((error) => console.log("error " + error));
  };
  const fetchSousAccounts = async () => {
    await jwtInterceoptor
      .get("/data/user/bq/accounts/" + organisation.id)
      .then((res) => {
        setSousComptes(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchSousAccountsCs = async () => {
    await jwtInterceoptor
      .get("/data/user/cs/accounts/" + organisation.id)
      .then((res) => {
        setSousComptesCs(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const checkIce = async (ice, type, next = true) => {
    const response = await jwtInterceoptor.post(
      `/data/draft/check_ice/${organisation.id}`,
      {
        ice,
        type,
      }
    );

    if (response.status == 200) {
      const data = response.data;
      if (data.status) {
        setClient(data.data);
        console.log(client);
      } else {
        setClient(null);
      }
      if (next) {
        onChange(step + 1);
      }
    }
  };

  const onNext = () => {
    setErrors([]);
    const errs = [];
    if (step == 0) {
      if (ice) {
        checkIce(ice, invoice.type, false);
      } else {
        errs.push("ice");
      }
      if (!invoiceDate) {
        errs.push("invoiceDate");
      }
      if (!invoiceDueDate) {
        errs.push("invoiceDueDate");
      }
      if (!subtotal) {
        errs.push("subtotal");
      }
      if (!tva) {
        errs.push("tva");
      }

      if (!total) {
        errs.push("total");
      }
      if (!selectedStatus) {
        errs.push("selectedStatus");
      }
      if (!titleInvoice) {
        errs.push("titleInvoice");
      }

      if (invoice?.type == "achat") {
        if (!typeAchat || typeAchat == 0) {
          errs.push("typeAchat");
        }
      }
      if (total && tva && subtotal) {
        var t_ttc = Number(parseFloat(tva) + parseFloat(subtotal)).toFixed(2);
        if (parseFloat(total).toFixed(2) != t_ttc) {
          console.log("ttc", total, "ttc calculer", t_ttc);
          errs.push("equal_ttc");
        }
      }

      if (errs.length == 0) {
        onChange(step + 1);
      } else {
        setErrors(errs);
      }
    } else {
      if (step == 1) {
        if (client) {
          onChange(step + 1);
        } else {
          setErrors([...errors, "client"]);
        }
      } else {
        if (step == 2) {
          if (invoice?.type == "achat") {
            if (typeAchat == "achat") {
              if (invoice_products.length > 0) {
                let t_pr_ttc = invoice_products.reduce((result, obj) => {
                  result += parseFloat(obj?.total_ttc);
                  console.log(result);
                  return result;
                }, 0);
                if (total && t_pr_ttc) {
                  if (parseFloat(total) != parseFloat(t_pr_ttc)) {
                    console.log(parseFloat(total) === t_pr_ttc);
                    setErrors(["pr_equal_ttc"]);
                  } else {
                    onChange(step + 1);
                  }
                }
              } else {
                setErrors(["products"]);
              }
            } else {
              if (invoicesDepenses.length > 0) {
                let t_pr_ttc = invoicesDepenses.reduce((result, obj) => {
                  result += parseFloat(obj?.total_ttc);
                  return result;
                }, 0);
                console.log(t_pr_ttc);
                console.log(total);
                if (total && t_pr_ttc) {
                  if (parseFloat(total) != t_pr_ttc) {
                    setErrors(["pr_equal_ttc"]);
                  } else {
                    onChange(step + 1);
                  }
                }
              } else {
                setErrors(["depenses"]);
              }
            }
          } else {
            if (invoice_products.length > 0) {
              let t_pr_ttc = invoice_products.reduce((result, obj) => {
                result += parseFloat(obj?.total_ttc);
                return result;
              }, 0);
              if (total && t_pr_ttc) {
                if (parseFloat(total) != t_pr_ttc) {
                  setErrors(["pr_equal_ttc"]);
                } else {
                  onChange(step + 1);
                }
              }
            } else {
              setErrors(["products"]);
            }
          }
        }
      }
    }
  };
  const onPrevious = () => onChange(step - 1);

  const getAllStatus = async () => {
    const response = await jwtInterceoptor.get(`/factures/status`);

    if (response.status === 200) {
      setStatuses(response.data.data);
    }
  };

  useEffect(() => {
    if (organisation.id) {
      fetchInvoices();
      getAllAssociatedProducts();
      getAllStatus();
      getAccounts();
      getPurchaseAccount();
      fetchTaxes();
      fetchSousAccounts();
      fetchSousAccountsCs();
      getNbsInvoices();
      fetchRlv();
      getSuppliers();
      getAllAssociatedClients();
    }
  }, []);

  const getPurchaseAccount = async () => {
    // We run axios, a promise is returned
    await jwtInterceoptor
      .get(baseURL + `/data/user/accounts/${organisation.id}`)
      .then((response) => {
        setPurchaseAccounts(response.data.data);
      })
      .catch((error) =>
        console.log("error while retrieving purshaseaccounts : " + error)
      );
  };

  const fetchTaxes = async () => {
    const response = await jwtInterceoptor.get(
      `/data/organisation_taxes/${organisation.id}`
    );

    if (response.status === 200) {
      let result = response.data.data.filter(
        (tx) =>
          tx.tax_type === "fournisseur" &&
          (tx.is_default_tax === 1 || tx.organisation_id === organisation.id)
      );
      setTaxes(result);
    }
  };

  const fetchInvoices = async () => {
    setLoadingData(true);
    const response = await jwtInterceoptor.get(
      `/data/draft/invoices/${organisation.id}`
    );

    if (response.status === 200) {
      setInvoices(response.data.data);
    }
    setLoadingData(false);
  };

  const [rlvs, setRlvs] = useState([]);

  const fetchRlv = async () => {
    setLoadingData(true);
    const response = await jwtInterceoptor.get(
      `/data/draft/rlv/${organisation.id}`
    );
    if (response.status === 200) {
      setRlvs(response.data);
    }
    setLoadingData(false);
  };

  const afterPdfSave = () => {
    $("#ImportInvModal").hide();
    $(".modal-backdrop").css({
      "background-color": "transparent",
      display: "none",
    });
    // Correction de la faute d’orthographe
    toast.success("Votre facture a été importée avec succès.", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
    fetchRlv();
  };

  const getAllAssociatedProducts = async (showPopup = false, modal = "") => {
    const response = await jwtInterceoptor
      .get(baseURL + `/product/getbyuser/${user.id}/${organisation.id}`)
      .then((response) => {
        setProducts(response.data.data);
        if (showPopup) {
          console.log("#" + modal);
          window.$("#" + modal).modal("show");
        }
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error)
      );
  };

  /**
   *
   * @param id
   * @param type
   * @return {Promise<void>}
   */
  const processing = async (id, type) => {
    setInvoiceDate("");
    try {
      setProcessingLoad(true);

      const response = await jwtInterceoptor.get(
        `/data/draft/processing/invoice/${id}`
      );

      if (response.status === 200) {
        console.log("*********************OCR*********************");

        console.log(response.data.data);
        setDataProcessing(response.data.data);
        const data = response.data.data;
        console.log("data: ", data);
        let date = "";
        if (typeof data["invoice_date"] === "string") {
          //sometimes it could be "31-01-2024"
          let dateForInput = "";
          date = data?.invoice_date.replace(/-/g, "/");
          const [year, month, day] = date.split("/");
          dateForInput = `${year}-${month}-${day}`;

          console.log("date: ", date);
          console.log("dateForInput: ", dateForInput);
          setInvoiceDate(dateForInput);
          //setInvoiceDate(data?.invoice_date != null ? moment(date.replaceAll("\\", ""),"DD/MM/YYYY").format("yyyy-MM-DD") : "");
        }

        //setInvoiceDueDate(data?.invoice_due_date != null ? moment(data?.invoice_due_date?.replaceAll("\\", "")).format("yyyy-MM-DD") : "");

        let sousTotal = "";
        if (typeof data["sous-total"] === "string") {
          sousTotal = data["sous-total"].replace(/\s/g, "").replace(",", ".");
        } else if (typeof data["sous-total"] === "number") {
          sousTotal = data["sous-total"];
        }

        let tva = "";
        if (typeof data["tva"] === "string") {
          tva = data["tva"].replace(/\s/g, "").replace(",", ".");
        } else if (typeof data["tva"] === "number") {
          tva = data["tva"];
        }

        let total = "";
        if (typeof data["total"] === "string") {
          total = data["total"].replace(/\s/g, "").replace(",", ".");
        } else if (typeof data["total"] === "number") {
          total = data["total"];
        }

        setSubtotal(sousTotal);
        setTotal(total);
        setTva(tva);
        //setTva(data?.tva);
        if (sousTotal && tva && total === 0) {
          setTotal(parseFloat(sousTotal) + parseFloat(tva));
        }
        if (sousTotal && total && tva === 0) {
          setTva(parseFloat(total) - parseFloat(sousTotal));
        }
        if (total && tva && subtotal === 0) {
          setSubtotal(parseFloat(total) - parseFloat(tva));
        }

        if (data?.ice) {
          if (data?.ice.length > 0) {
            if (data?.ice.length > 1) {
              if (parseInt(data?.ice[0]) !== organisation?.ice) {
                setIce(data?.ice[0]);
              }
              if (parseInt(data?.ice[1]) !== organisation?.ice) {
                setIce(data?.ice[1]);
              }
            } else {
              if (parseInt(data?.ice[0]) !== organisation?.ice) {
                setIce(data?.ice[0]);
              } else {
                setIce(null);
              }
            }
          } else {
            setIce(null);
          }
        }
        setProcessingLoad(false);
        console.log("*********************OCR END*********************");
      } else {
        console.log("*********************OCR ELSE*********************");
      }
    } catch (error) {
      console.log("*********************OCR CATCH*********************");
      console.log("error : ", error.message);

      setProcessingLoad(false);
    }
  };

  const [dataProcessingRlv, setDataProcessingRlv] = useState([]);
  const [rlv, setRlv] = useState(null);
  const [souscompteRlvBq, setSouscompteRlvBq] = useState(" ");
  const [soldeDepart, setSoldeDepart] = useState(0);

  /**
   *
   * @param id
   * @param type
   * @return {Promise<void>}
   */

  const processingRlv = async (rlvss) => {
    setRlv(rlvss);
    setProcessingLoad(true);
    try {
      const response = await jwtInterceoptor.get(
        `/data/draft/processing/rlv/${rlvss.id}`
      );

      if (response.status === 200) {
        console.log("*********************OCR*********************");

        // Convertir `data` de string en JSON
        const rawData = JSON.parse(response.data.data);
        //initialze the solde de depart
        setSoldeDepart(rawData.solde_depart);
        // Regrouper les opérations par date
        const transformedData = Object.values(
          rawData.transactions.reduce((acc, item) => {
            const date = item.date || "N/A";

            if (!acc[date]) {
              acc[date] = {
                date,
                year: "",
                operations: [],
              };
            }

            acc[date].operations.push({
              libille: item.operation || "Libellé inconnu",
              account: null, // Remplace par la vraie donnée si dispo
              debit: item.debit ? parseFloat(item.debit).toFixed(2) : "0.00",
              credit: item.credit ? parseFloat(item.credit).toFixed(2) : "0.00",
              type: "initial",
            });
            acc[date].operations.push({
              libille: "    ",
              account: souscompteRlvBq,
              debit:
                item.debit == "0" ? parseFloat(item.credit).toFixed(2) : "0.00",
              credit:
                item.credit == "0" ? parseFloat(item.debit).toFixed(2) : "0.00",
              type: "contrePartie",
            });
            return acc;
          }, {})
        );

        setDataProcessingRlv(transformedData);
        console.log("dataProcessingRlv: ", transformedData);
        // data format =>[
        // {
        // date:"01/02",
        // libille:"libille",
        // operations:[{account:"1222",debit:100,credit:0},...]
        // },
        // ...]
      }
    } catch (er) {
      console.log(er);
    } finally {
      setProcessingLoad(false);
    }
  };

  const initData = () => {
    setProcessingLoad(false);
    setDataProcessing(null);
    setInvoice(null);
    setClient(null);
    setIce(null);
    setErrors([]);
    setStep(0);
    setInvoiceProducts([]);
    setSelectedProduct(null);
    setTitleInvoice(null);
    setChequeId(null);
    setPaymentType(null);
    //setBqAccountId(null);
    setPayedAmount(0);
    setSelectedStatus(0);
    setTypeAchat(null);
    setInvoicesDepenses([]);
    setDesignationAcc("");
    setAccount({ id: 0 });
    setTaxeAcc({ id: 0 });
    setTotalDepenseAcc(0);
    ref_desg.current.value = "";
    if (document.getElementById("data-invoice")) {
      document.getElementById("data-invoice").reset();
    }
  };

  const getEcritureComptableEco = async (invoice) => {
    setLoading(1);
    getAccounts();
    getPurchaseAccount();
    fetchSousAccounts();
    fetchSousAccountsCs();

    getEcEco(invoice)
      .then((flux) => {
        console.log("flux: ", flux);
        setFluxEco([flux]);
        setLoading(0);
      })
      .catch((error) => {
        console.log("error while returing ec fluxeco : ", error);
      });
  };

  const deleteItem = async (inv) => {
    Swal.fire({
      title: t("Are you sure?"),
      text: t("You won't be able to revert this!"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: t("Yes, delete it!"),
      cancelButtonText: t("Cancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await jwtInterceoptor.delete(
          inv.type == "RLV"
            ? `/data/draft/rlv/delete/${inv.id}`
            : `/data/draft/invoices/delete/${inv.id}`
        );

        if (response.status === 200) {
          if (response.data.status == true) {
            let invs = invoices.filter((el) => el.id != inv.id);
            setInvoices(invs);
            //check if the deleted record is a RLV
            let rs = rlvs.filter((el) => el.id == inv.id);
            if (rs[0].type == "RLV") {
              let rlv = rlvs.filter((el) => el.id != inv.id);
              setRlvs(rlv);
            }
            Swal.fire(
              t("Deleted!"),
              t("Your record has been deleted."),
              "success"
            );

            return;
          }
        }

        Swal.fire({
          icon: "warning",
          title: "",
          text: t("Something went wrong!, try again"),
        });
      }
    });
  };

  const columns = [
    {
      flex: 1,
      field: "Type",
      headerName: t("Type"),
      valueGetter: (params) =>
        `${
          params.row.type === "RLV"
            ? "Relevé bancaire"
            : "Facture de " + params.row.type
        }`,
    },
    {
      flex: 1,
      field: "Date d'importation",
      headerName: t("Date d'importation"),
      valueGetter: (params) => {
        const date = new Date(params.row.created_at);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      },
    },
    {
      field: "Traitement",
      headerName: t("Traitement"),
      width: 210,
      sortable: false,
      disableClickEventBubbling: true,

      renderCell: (params) => {
        const onProcessing = (e) => {
          const inv = params.row;
          if (inv.type !== "RLV") {
            setInvoice(inv);
            processing(inv?.id, inv?.type);
            window.$("#fullscreenmodal").modal("show");
          } else {
            console.log("RLV", inv);
            processingRlv(inv);
            window.$("#fullscreenmodalRLV").modal("show");
          }
        };

        return (
          <div className="btn-list">
            <button
              onClick={onProcessing}
              id="bProcessing"
              type="button"
              className="btn  btn-sm btn-warning"
            >
              <span className="fe fe-refresh-cw"> </span>
              <span>Commencer le traitement</span>
            </button>
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: t("ACTIONS"),
      width: 180,
      sortable: false,
      disableClickEventBubbling: true,

      renderCell: (params) => {
        const onDelete = (e) => {
          const inv = params.row;
          return deleteItem(inv);
        };

        const onDetails = (e) => {
          const inv = params.row;
          setPreviewImg(inv?.file);
          window.$("#staticBackdrop").modal("show");
        };

        const onDownload = async (e) => {
          try {
            const data = params.row;
            const response = await jwtInterceoptor.get(
              data.type !== "RLV"
                ? `/data/draft/get-draft/${data.id}`
                : `/data/draft/get-draft-rlv/${data.id}`,
              { responseType: "arraybuffer" }
            );
            if (response.status === 200) {
              const type = response.headers["content-type"];
              const blob = new Blob([response.data], {
                type: type,
                encoding: "UTF-8",
              });
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = data.type + data.id;
              link.click();
            }
          } catch (error) {
            if (error.response) {
              console.log("Error data: ", error.response.data);
              console.log("Status: ", error.response.status);
              console.log("Headers: ", error.response.headers);
            } else {
              console.log("Error message: ", error.message);
            }
          }
        };

        return (
          <div className="btn-list">
            <button
              onClick={onDetails}
              id="bEdit"
              type="button"
              className="btn  btn-sm btn-primary"
            >
              <span className="fe fe-eye"> </span>
            </button>

            <button
              onClick={onDelete}
              id="bDel"
              type="button"
              className="btn  btn-sm btn-danger"
            >
              <span className="fe fe-trash-2"> </span>
            </button>
            <button onClick={onDownload} className="btn  btn-sm btn-warning">
              <span className="fe fe-download"> </span>
            </button>
          </div>
        );
      },
    },
  ];

  const afterSave = (data) => {
    if (data?.ice) {
      setIce(data.ice);
      checkIce(ice, invoice?.type, false);
    }
  };

  const selectProd = useRef();
  const inputPrice = useRef();
  const inputQuantity = useRef();
  const inputTotalTcc = useRef();

  const [selectedStatus, setSelectedStatus] = useState(null);
  const [payedAmount, setPayedAmount] = useState(0);
  const [banqueAccounts, setBanqueAccounts] = useState([]);
  const [bqAccountId, setBqAccountId] = useState(0);
  const [caisseAccountId, setCaisseAccountId] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [banquePaymentOption, setBanquePaymentOption] = useState("");
  const [chequeId, setChequeId] = useState("");
  const [titleInvoice, setTitleInvoice] = useState(null);
  const [typeAchat, setTypeAchat] = useState(null);

  // Depenses
  const ref_desg = useRef();
  const [invoicesDepenses, setInvoicesDepenses] = useState([]);
  const [designationAcc, setDesignationAcc] = useState("");
  const [Acc, setAccount] = useState({ id: 0 });
  const [taxeAcc, setTaxeAcc] = useState({ id: 0 });
  const [totalDepenseAcc, setTotalDepenseAcc] = useState(null);

  const closeModalAddProduct = () => {
    window.$("#modalAddProduct").modal("hide");
    // inputPrice.current.value = null;
    // inputQuantity.current.value = null;
    // inputTotalTcc.current.value = null;
    selectProd.current.value = 0;
    setSelectedProduct(null);
    window.$("#input-qty").removeClass("is-invalid state-invalid");
  };

  const closeModalAddDepense = () => {
    setDesignationAcc("");
    setAccount({ id: 0 });
    setTaxeAcc({ id: 0 });
    setTotalDepenseAcc(0);
    ref_desg.current.value = "";
    window.$("#modalAddDepense").modal("hide");
  };

  const deleteProduct = (id) => {
    var new_invoice_products = invoice_products.filter((p) => p?.id != id);
    setInvoiceProducts(new_invoice_products);
  };

  const getAccounts = async () => {
    await jwtInterceoptor
      .get(baseURL + "/paymentAccounts")
      .then((response) => {
        setBanqueAccounts(response.data.data);
        response.data.data.map((a) => {
          if (a.name === "Banques (soldes débiteurs)") {
            setBqAccountId(a.id);
          } else if (a.name === "Caisses") {
            setCaisseAccountId(a.id);
          }
        });
        console.log("banque accout: ", banqueAccounts);
      })
      .catch((error) =>
        console.log("error while retrieving setBanqueAccounts : " + error)
      );
  };

  const save = (event) => {
    setLoadingSa(true);
    event.preventDefault();
    setIsSauvguarded(true);
    if (invoice) {
      if (invoice.type == "vente") {
        saveVente();
      }

      if (invoice.type == "achat") {
        if (typeAchat == "achat") {
          saveInvoiceAchat();
        }
        if (typeAchat == "depense") {
          saveInvoiceDepense();
        }
      }
      getPurchaseAccount();
      setLoadingSa(false);
    }
  };

  const saveVente = () => {
    let isOkToSave = true;
    // etat = créer
    if (selectedStatus === "1") {
      setPaymentType("");
      setBanquePaymentOption("");
      setChequeId();
    }

    //etat= payé
    if (
      selectedStatus == "2" &&
      (paymentType.length === 0 || invoiceStatusCreatedAt.length === 0)
    ) {
      isOkToSave = false;
    }
    if (
      selectedStatus == "2" &&
      paymentType.length !== 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      if (paymentType === caisseAccountId.toString()) {
        isOkToSave = true;
      } else {
        if (banquePaymentOption.length === 0) {
          isOkToSave = false;
        } else {
          if (banquePaymentOption === "chéque" && chequeId.length === 0) {
            isOkToSave = false;
          }
        }
      }
    }
    //etat = payé en partie
    if (
      selectedStatus == "3" &&
      (paymentType.length === 0 || invoiceStatusCreatedAt.length === 0)
    ) {
      isOkToSave = false;
    }

    if (
      selectedStatus == "3" &&
      paymentType.length !== 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      if (paymentType !== bqAccountId && payedAmount === 0) {
        isOkToSave = false;
      } else {
        if (paymentType === bqAccountId && banquePaymentOption.length === 0) {
          isOkToSave = false;
        } else {
          if (banquePaymentOption === "chéque" && chequeId.length === 0) {
            isOkToSave = false;
          }
        }
      }
    }
    if (
      selectedStatus == "3" &&
      paymentType.length !== 0 &&
      payedAmount === 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      isOkToSave = false;
    }

    if (
      paymentType.length !== 0 &&
      paymentType === bqAccountId.toString() &&
      (sousCompte.length === 0 || sousCompte === 0)
    ) {
      isOkToSave = false;
    }

    if (
      paymentType.length !== 0 &&
      paymentType === caisseAccountId.toString() &&
      (sousCompteCs.length === 0 || sousCompteCs === 0 || sousCompteCs === "0")
    ) {
      isOkToSave = false;
    }

    if (isOkToSave) {
      // $(".all-fields-are-required-to-save").css('display', 'none');
      let numeroDeFacture = 0;
      let is_custom_invoice_number = 0;
      if (!autoIncrementInvoiceNumber) {
        is_custom_invoice_number = 1;
        numeroDeFacture = isNumeric(invoiceNumber)
          ? `FACT-VENTE-${formatNumber(invoiceNumber)}`
          : `FACT-VENTE-${invoiceNumber}`;
      } else {
        numeroDeFacture = `FACT-VENTE-${nbInvoices + 1}`;
      }
      /**
       * {
       *     "product_id": 75,
       *     "name": "Funny Morning Sarcastic SVG, Sarcastic Morning SVG, Sarcastic SVG, Sarcasm svg, Funny Mug svg,Cut File for Cricut,Silhouette",
       *     "qty": "1",
       *     "unitPrice": 100,
       *     "tva": 20,
       *     "totalHt": "100",
       *     "totalTtc": "120"
       * }
       * @type {*[]}
       */
      let preparedProducts = [];

      for (let i = 0; i < invoice_products.length; i++) {
        const ref = Math.random().toString(36).substring(2, 7);
        var price =
          invoice?.type == "vente"
            ? invoice_products[i]?.sellingPrice
            : invoice_products[i]?.costPrice;
        let obj = {
          product_id: invoice_products[i]?.id,
          price_unit_ht: invoice_products[i].price_unit_ht,
          qty: invoice_products[i].quantity,
          total_ht: invoice_products[i].total_ht,
          total_ttc: invoice_products[i].total_ttc,
          tva: invoice_products[i]?.taxe_vente?.rate,
          reference: ref,
        };
        preparedProducts.push(obj);
      }

      // const prepareObject = {
      //     organisation_id: organisation?.id,
      //     client_id: client?.id,
      //     total_ht: subtotal,
      //     total_ttc: total,
      //     total_tva: tva,
      //     title: titleInvoice,
      //     due_date: invoiceDueDate,
      //     payed_amount: payedAmount,
      //     products: preparedProducts,
      //     invoice_number: "Fact-",
      //     is_custom_invoice_number: 0,
      //     payment_method: paymentType === '' ? 0 : paymentType,
      //     payment_account: paymentType,
      //     banquePaymentOption: banquePaymentOption,
      //     chequeId: chequeId,
      //     status: selectedStatus,
      //     ocr: true,
      //     draft_id: invoice.id
      // };
      let formData = new FormData();
      formData.append("organisation_id", organisation.id);
      console.log("organisation.id", organisation.id);
      formData.append("client_id", client?.id);
      console.log("client_id", client?.id);
      formData.append("total_ht", subtotal);
      formData.append("total_ttc", total);
      formData.append("total_tva", tva);

      formData.append("title", titleInvoice);
      formData.append("due_date", invoiceDueDate);
      formData.append("date", invoiceDate);
      formData.append("status", selectedStatus);
      formData.append("payed_amount", payedAmount);

      formData.append("products", JSON.stringify(preparedProducts));
      formData.append("invoice_number", numeroDeFacture);
      formData.append("is_custom_invoice_number", is_custom_invoice_number);
      //formData.append("payment_method", paymentType === '' ? 0 : paymentType);
      formData.append("payment_method", sousCompte === "" ? 0 : sousCompte);

      //formData.append("payment_account", sousCompte);

      if (paymentType === bqAccountId.toString()) {
        formData.append("payment_account", sousCompte);
      } else if (paymentType === caisseAccountId.toString()) {
        formData.append("payment_account", sousCompteCs);
      }

      if (paymentType === bqAccountId.toString()) {
        formData.append("banquePaymentOption", banquePaymentOption);
        formData.append("chequeId", chequeId);
      } else {
        formData.append("banquePaymentOption", "");
        formData.append("chequeId", "");
      }

      //formData.append("payment_account", paymentType);
      // formData.append("banquePaymentOption", banquePaymentOption);
      // formData.append("chequeId", chequeId);
      formData.append("payed_invoice_created_at", invoiceStatusCreatedAt);

      formData.append("ocr", true);
      formData.append("draft_id", invoice.id);
      formData.append("attachment_file", invoice?.file);
      for (let pair of formData.entries()) {
        console.log(pair[0] + ": " + pair[1]);
      }
      saveInvoice(formData);
    } else {
      const errorMessage = "Merci de remplir tout les champs obligatoire !";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const saveInvoice = async (invoice) => {
    console.log(invoice);
    const response = await jwtInterceoptor
      .post("/data/user/factures/add", invoice, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        toast.success("La facture a été ajoutée avec succès.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        window.$("#fullscreenmodal").modal("hide");
        window.$("#fullscreenmodal4ec").modal("show");
        setInvoiceId(res.data.data.id);
        setInvoiceType(res.data.data.type);
        validerEc(res.data.data);
      })
      .catch((error) => console.log("error while save", error));
  };

  const saveInvoiceAchat = async () => {
    let isOkToSave = true;
    if (selectedStatus === "1") {
      setPaymentType("");
      setBanquePaymentOption("");
      setChequeId();
    }

    //etat= payé
    if (
      selectedStatus === "2" &&
      (paymentType.length === 0 || invoiceStatusCreatedAt.length === 0)
    ) {
      isOkToSave = false;
    }
    if (
      selectedStatus === "2" &&
      paymentType.length !== 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      if (paymentType === caisseAccountId.toString()) {
        isOkToSave = true;
      } else {
        if (banquePaymentOption.length === 0) {
          isOkToSave = false;
        } else {
          if (banquePaymentOption === "chéque" && chequeId.length === 0) {
            isOkToSave = false;
          }
        }
      }
    }

    //etat = payé en partie
    if (
      selectedStatus === "3" &&
      (paymentType.length === 0 || invoiceStatusCreatedAt.length === 0)
    ) {
      isOkToSave = false;
    }

    if (
      selectedStatus === "3" &&
      paymentType.length !== 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      if (paymentType !== bqAccountId && payedAmount === 0) {
        isOkToSave = false;
      } else {
        if (paymentType === bqAccountId && banquePaymentOption.length === 0) {
          isOkToSave = false;
        } else {
          if (banquePaymentOption === "chéque" && chequeId.length === 0) {
            isOkToSave = false;
          }
        }
      }
    }

    if (
      selectedStatus === "3" &&
      paymentType.length !== 0 &&
      payedAmount === 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      isOkToSave = false;
    }

    if (
      paymentType.length !== 0 &&
      paymentType === bqAccountId.toString() &&
      (sousCompte.length === 0 || sousCompte === 0)
    ) {
      isOkToSave = false;
    }

    if (
      paymentType.length !== 0 &&
      paymentType === caisseAccountId.toString() &&
      (sousCompteCs.length === 0 || sousCompteCs === 0 || sousCompteCs === "0")
    ) {
      isOkToSave = false;
    }

    if (isOkToSave) {
      let preparedProducts = [];

      //facture achat products
      for (let i = 0; i < invoice_products.length; i++) {
        const ref = Math.random().toString(36).substring(2, 7);
        var price =
          invoice?.type == "vente"
            ? invoice_products[i]?.sellingPrice
            : invoice_products[i]?.costPrice;
        let obj = {
          product_id: invoice_products[i]?.id,
          price_unit_ht: price,
          qty: invoice_products[i].quantity,
          total_ht: invoice_products[i].total_ht,
          total_ttc: invoice_products[i].total_ttc,
          tva: invoice_products[i]?.taxe_achat?.rate,
          reference: ref,
        };
        preparedProducts.push(obj);
      }

      console.log("obj: ", preparedProducts);

      let numeroDeFacture = 0;
      let is_custom_invoice_number = 0;
      if (!autoIncrementInvoiceNumber) {
        is_custom_invoice_number = 1;
        numeroDeFacture = isNumeric(invoiceNumber)
          ? `FACT-ACHAT-${formatNumber(invoiceNumber)}`
          : `FACT-ACHAT-${invoiceNumber}`;
      } else {
        numeroDeFacture = `FACT-ACHAT-${nbInvoices + 1}`;
      }

      let formData = new FormData();
      formData.append("organisation_id", organisation.id);
      console.log("organisation.id", organisation.id);
      formData.append("supplier_id", client?.id);
      console.log("supplier_id", client?.id);
      formData.append("date", invoiceDate);
      formData.append("price_ut", 0);
      formData.append("invoice_number", numeroDeFacture);
      formData.append("is_custom_invoice_number", is_custom_invoice_number);
      formData.append("attachment_file", invoice?.file);
      formData.append("payment_method", sousCompte === "" ? 0 : sousCompte);
      //formData.append("payment_method", paymentType === '' ? 0 : paymentType,);
      formData.append("status", selectedStatus);
      formData.append("payed_amount", payedAmount);

      if (paymentType === bqAccountId.toString()) {
        formData.append("payment_account", sousCompte);
      } else if (paymentType === caisseAccountId.toString()) {
        formData.append("payment_account", sousCompteCs);
      }

      if (paymentType === bqAccountId.toString()) {
        formData.append("banquePaymentOption", banquePaymentOption);
        formData.append("chequeId", chequeId);
      } else {
        formData.append("banquePaymentOption", "");
        formData.append("chequeId", "");
      }

      // formData.append("payment_account", sousCompte);
      // formData.append("banquePaymentOption", banquePaymentOption);
      // formData.append("chequeId", chequeId);

      formData.append("payed_invoice_created_at", invoiceStatusCreatedAt);

      formData.append("total", subtotal);
      formData.append("total_tva", tva);
      formData.append("total_ttc", total);
      formData.append("due_date", invoiceDueDate);
      formData.append("products", JSON.stringify(preparedProducts));

      formData.append("ocr", true);
      formData.append("draft_id", invoice?.id);
      for (let pair of formData.entries()) {
        console.log(pair[0] + ": " + pair[1]);
      }
      const response = await jwtInterceoptor
        .post("/data/user/factures_achat/add", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          toast.success("La facture a été ajouter avec succès", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          window.$("#fullscreenmodal").modal("hide");
          window.$("#fullscreenmodal4ec").modal("show");

          console.log("response: ", res);
          setInvoiceId(res.data.data.id);
          setInvoiceType(res.data.data.type);
          validerEc(res.data.data);
        })
        .catch((error) => console.log("error while save", error));
    } else {
      const errorMessage = "Merci de remplir tout les champs obligatoire !";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const validerEc = (invoice) => {
    window.$("#fullscreenmodal").modal("hide");
    window.$("#fullscreenmodal4ec").modal("show");
    getEcritureComptableEco(invoice);
  };

  const AddProducts = () => {
    return (
      <div>
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Produits</h3>
            </div>
            <div className="card-body">
              {errors.includes("products") ? (
                <div>
                  <span className="text-danger">Ajouter des produits</span>
                </div>
              ) : null}
              {errors.includes("pr_equal_ttc") ? (
                <div>
                  <span className="text-danger">
                    le total TVA et le sous-total doivent être égaux au Total
                  </span>
                </div>
              ) : null}
              <button
                className="btn btn-primary mb-4"
                onClick={() => {
                  window.$("#modalAddProduct").modal("show");
                }}
              >
                {" "}
                Ajouter
              </button>
              <div
                className="table-responsive"
                style={{
                  height: 270,
                  overflow: "scroll",
                  overflowX: "scroll",
                }}
              >
                <table className="table text-nowrap text-md-nowrap mb-0">
                  <thead>
                    <tr>
                      <th>Article</th>
                      <th>Prix</th>
                      <th>Quantité</th>
                      <th>Total TTC</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice_products.map((product) => (
                      <tr>
                        <td>{product?.name}</td>
                        <td>{Number(product?.price_unit_ht).toFixed(2)}</td>
                        <td>{product?.quantity}</td>
                        <td>{Number(product?.total_ttc).toFixed(2)}</td>
                        <td>
                          <button
                            onClick={() => {
                              deleteProduct(product?.id);
                            }}
                            id="bDelProduct"
                            type="button"
                            className="btn  btn-sm btn-danger"
                          >
                            <span className="fe fe-trash-2"> </span>
                          </button>
                        </td>
                        <td>
                          <button
                            className="btn  btn-sm btn-primary"
                            onClick={() => {
                              window.$("#modalAddProduct").modal("show");
                              setSelectedProduct(product);
                              if (product.type == "Services") {
                                setIsService(true);
                              } else {
                                setIsService(false);
                              }
                            }}
                          >
                            <span class="fe fe-edit-2"></span>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const deleteDepense = (id) => {
    var new_invoicesDepenses = invoicesDepenses.filter((p) => p?.id != id);
    setInvoicesDepenses(new_invoicesDepenses);
  };
  const editDepense = (id) => {
    const prdSe = invoicesDepenses.filter((p) => p?.id == id);
    setProductEdit(prdSe);
    setIsEdit(true);
    setDesignationAcc(productEdit[0].designation);
    setTotalDepenseAcc(productEdit[0].total_ht);
    let taxeSelected = taxes.filter(
      (taxe) => taxe.name === productEdit[0].taxe_name
    );
    let accountSelected = purchaseAccounts.filter(
      (acc) => acc.id === productEdit[0].account_id
    );
    setTaxeAcc(taxeSelected[0]);
    setAccount(accountSelected[0]);
    console.log(productEdit);
    console.log(taxes.filter((taxe) => taxe.name === productEdit[0].taxe_name));
    console.log(designationAcc);
    window.$("#modalAddDepense").modal("show");
  };
  const saveInvoiceDepense = async () => {
    let isOkToSave = true;

    // Reset payment-related fields if the status is "1" (unpaid)
    if (selectedStatus === "1") {
      setPaymentType("");
      setBanquePaymentOption("");
      setChequeId("");
    }

    // Helper function to validate fields for "paid" and "partially paid" statuses
    const isValidPaymentFields = (status) => {
      if (status === "2" || status === "3") {
        if (paymentType.length === 0 || invoiceStatusCreatedAt.length === 0)
          return false;
        if (paymentType === caisseAccountId.toString()) return true;

        if (banquePaymentOption.length === 0) return false;
        if (banquePaymentOption === "chéque" && chequeId.length === 0)
          return false;
      }
      return true;
    };

    // Validate "paid" status
    if (selectedStatus === "2" && !isValidPaymentFields("2")) {
      isOkToSave = false;
    }

    // Validate "partially paid" status
    if (selectedStatus === "3" && !isValidPaymentFields("3")) {
      isOkToSave = false;
    }

    // Additional validation for payment accounts
    if (
      paymentType.length !== 0 &&
      paymentType === bqAccountId.toString() &&
      (sousCompte.length === 0 || sousCompte === 0)
    ) {
      isOkToSave = false;
    }

    if (
      paymentType.length !== 0 &&
      paymentType === caisseAccountId.toString() &&
      (sousCompteCs.length === 0 || sousCompteCs === 0 || sousCompteCs === "0")
    ) {
      isOkToSave = false;
    }

    // Proceed with saving the invoice if validation passes
    if (isOkToSave) {
      // Ensure that the organisation, client, and invoice objects are defined
      let is_custom_invoice_number = 0;
      let numeroDeFacture = "";

      if (!organisation || !organisation.id)
        throw new Error("Organisation ID is missing");
      if (!client || !client.id) throw new Error("Client ID is missing");
      if (!invoice || !invoice.id) throw new Error("Invoice ID is missing");

      if (!autoIncrementInvoiceNumber) {
        is_custom_invoice_number = 1;
        numeroDeFacture = isNumeric(invoiceNumber)
          ? `FACT-DEPENSE-${formatNumber(invoiceNumber)}`
          : `FACT-DEPENSE-${invoiceNumber}`;
      } else {
        numeroDeFacture = `FACT-DEPENSE-${nbInvoices + 1}`;
      }

      // Create formData for the POST request
      let formData = new FormData();
      formData.append("organisation_id", organisation.id);
      formData.append("supplier_id", client.id);
      formData.append("total_ttc", total);
      formData.append("total_ht", subtotal);
      formData.append("total_tva", tva);
      formData.append("due_date", invoiceDueDate);
      formData.append("invoice_number", numeroDeFacture);
      formData.append("is_custom_invoice_number", is_custom_invoice_number);
      formData.append("attachment_file", invoice.file);
      formData.append("status", selectedStatus);
      formData.append("spent_accounts", JSON.stringify(invoicesDepenses));
      formData.append("payed_invoice_created_at", invoiceStatusCreatedAt);
      formData.append("payed_amount", payedAmount);
      formData.append("ocr", 1);
      formData.append("draft_id", invoice.id);
      formData.append("date", invoiceDate);

      // Handle payment account and cheque information based on payment type
      if (paymentType === bqAccountId.toString()) {
        formData.append("payment_account", sousCompte);
        formData.append("banquePaymentOption", banquePaymentOption);
        formData.append("chequeId", chequeId);
      } else if (paymentType === caisseAccountId.toString()) {
        formData.append("payment_account", sousCompteCs);
        formData.append("banquePaymentOption", "");
        formData.append("chequeId", "");
      }

      // Debugging logs
      console.log("Organisation:", organisation);
      console.log("Client:", client);
      console.log("Invoice:", invoice);

      try {
        const response = await jwtInterceoptor.post(
          "/data/user/factures_depenses/add",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        toast.success("La facture a été ajoutée avec succès", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        window.$("#fullscreenmodal").modal("hide");
        window.$("#fullscreenmodal4ec").modal("show");

        setInvoiceId(response.data.data.id);
        setInvoiceType(response.data.data.type);
        validerEc(response.data.data);
        console.log(formData);
      } catch (error) {
        console.error("Error while saving:", error);
        toast.error("Merci de remplir tous les champs obligatoires !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };

  const savePiece = () => {
    console.log("ocr_ec onSave 2");

    initData();
    fetchInvoices();
    Swal.fire(
      t("Votre nouvelle écriture comptable a été ajouter avec succès"),
      t(""),
      "success"
    );
    window.$("#fullscreenmodal4ec").modal("hide");
  };

  const onSaveNewProduct = () => {
    window.$("#modalNewAddProduct").modal("hide");
    window.$("#modalAddProduct").modal("hide");
    getAllAssociatedProducts(true, "modalAddProduct");
  };

  const [hasErrorUpload, setHasErrorUpload] = useState(false);
  const [hasSuccessUpload, setHasSuccessUpload] = useState(false);
  const [errorUpload, setErrorUpload] = useState("");
  const [importType, setImportType] = useState(null);
  const [invType, setInvType] = useState(null);
  const [isSubmitToSave, setIsSubmitToSave] = useState(false);
  const [selectedImageInv, setSelectedImageInv] = useState(null);
  const [sevePdf, setSavePdf] = useState(false);
  const [clearPdf, setClearPdf] = useState(false);

  const handleSavePdf = () => {
    console.log("hdhsdhs");
    setSavePdf(false);
    setImportType(null);
    setInvType(null);
    fetchInvoices();
  };

  const onFileUploadImage = (event) => {
    if (event.target?.files[0]) {
      if (event.target?.files[0].size > 2 * 1024 * 1024) {
        alert("Fichier trop gros !");
        return;
      }
      console.log("event.target.files[0] : " + event.target.files[0]);
      setSelectedImageInv(event.target.files[0]);
    } else {
      console.log("else");
    }
  };

  const [selectedImageRlv, setSelectedImageRlv] = useState(null);
  const onFileUploadImageRlv = (event) => {
    if (event.target?.files[0]) {
      if (event.target?.files[0].size > 2 * 1024 * 1024) {
        alert("Fichier trop gros !");
        return;
      }
      console.log("event.target.files[0] : " + event.target.files[0]);
      setSelectedImageRlv(event.target.files[0]);
    } else {
      console.log("else");
    }
  };

  const initDataUpload = () => {
    setHasErrorUpload(false);
    setHasSuccessUpload(false);
    setErrorUpload("");
    setImportType(null);
    setInvType(null);
    setSelectedImageInv(null);
    setClearPdf(true);
  };

  const handleClear = () => {
    setClearPdf(false);
  };
  const handleAutoIncrementInvoiceNumber = () => {
    if (autoIncrementInvoiceNumber === false) {
      $("#invoiceNumberInput").css("display", "none");
    } else {
      $("#invoiceNumberInput").css("display", "block");
    }
  };

  const uploadInv = async () => {
    setIsSubmitToSave(true);
    setHasSuccessUpload(false);
    setHasErrorUpload(false);
    setErrorUpload("");
    if (importType == null || invType == null || selectedImageInv == null) {
      setHasErrorUpload(true);
      setErrorUpload("Remplissez tous les champs");
      setIsSubmitToSave(false);
      return;
    }
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    const dataForm = new FormData();
    dataForm.append("invoice", selectedImageInv);
    dataForm.append("org_id", organisation?.id);
    dataForm.append("type", invType);

    jwtInterceoptor
      .post("/data/uploadInvoice", dataForm, config)
      .then((res) => {
        console.log(res);
        setIsSubmitToSave(false);
        initDataUpload();
        setHasSuccessUpload(true);
        $("#ImportInvModal").hide();
        $(".modal-backdrop").css({
          "background-color": "transparent",
          display: "none",
        });
        // Correction de la faute d’orthographe
        toast.success("Votre facture a été importée avec succès.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        fetchInvoices();
      })
      .catch((err) => {
        console.error(err);
        setHasErrorUpload(true);
        setErrorUpload("Facture non importée, réessayez");
        setIsSubmitToSave(false);
      });
  };

  const uploadRlv = async () => {
    setIsSubmitToSave(true);
    setHasSuccessUpload(false);
    setHasErrorUpload(false);
    setErrorUpload("");
    if (selectedImageRlv == null) {
      setHasErrorUpload(true);
      setErrorUpload("Remplissez tous les champs");
      setIsSubmitToSave(false);
      return;
    }
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    const dataForm = new FormData();
    dataForm.append("rlv", selectedImageRlv);
    dataForm.append("org_id", organisation?.id);

    jwtInterceoptor
      .post("/data/uploadRlv", dataForm, config)
      .then((res) => {
        console.log(res);
        setIsSubmitToSave(false);
        initDataUpload();
        setHasSuccessUpload(true);
        $("#ImportRlvModal").hide();
        $(".modal-backdrop").css({
          "background-color": "transparent",
          display: "none",
        });
        toast.success("Votre relevé bancaire a été importer avec succès", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        fetchRlv();
      })
      .catch((err) => {
        console.error(err);
        setHasErrorUpload(true);
        setErrorUpload("relevé bancaire non importée, réessayez");
        setIsSubmitToSave(false);
      });
  };
  const [dateRlv, setDateRlv] = useState(" ");
  const [stepRlv, setStepRlv] = useState(1);
  const [libelle, setLibelle] = useState("");
  const [trAccount, setTrAccount] = useState("");
  const [debit, setDebit] = useState(0);
  const [credit, setCredit] = useState(0);
  const [index, setIndex] = useState();
  const [isNewOp, setIsNewOp] = useState(false);
  const [dateOp, setDateOp] = useState("");

  const getMonthName = (monthNumber) => {
    const months = [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ];
    return months[parseInt(monthNumber) - 1] || "Mois invalide"; // -1 car index commence à 0
  };
  const initDataRlv = () => {
    setDateRlv(" ");
    setStepRlv(1);
    setLibelle("");
    setTrAccount("");
    setDebit(0);
    setCredit(0);
    setIndex();
    setIsNewOp(false);
    setDateOp("");
    setDataProcessingRlv("");
    setSoldeDepart(0);
  };
  const [selectCF, setSelectCF] = useState(false);
  return (
    <>
      <ToastContainer />
      <div
        className="modal fade"
        id="ImportInvModal"
        tabIndex="-1"
        data-bs-backdrop="static"
        aria-hidden="true"
        aria-labelledby="staticBackdropLabel"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content" style={{ height: "85vh" }}>
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="newClientModal">
                {t("Importer votre facture.")}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={initDataUpload}
              >
                <i class="fe fe-x"></i>
              </button>
            </div>
            <div className="modal-body" style={{ overflowY: "auto" }}>
              <div className="row">
                <div className={"col-md-3"}></div>
                <div className={"col-md-6"}>
                  {hasErrorUpload ? (
                    <div className={"row"}>
                      <div className={`text-danger bg-danger-transparent card`}>
                        <div className="card-body">
                          <h5 className="card-title text-center">
                            {errorUpload}
                          </h5>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {/*{hasSuccessUpload ? (<div className={"row"}>*/}
                  {/*    <div*/}
                  {/*        className={`text-success bg-success-transparent card`}*/}
                  {/*    >*/}
                  {/*        <div className="card-body">*/}
                  {/*            <h5 className="card-title text-center">Facture importé avec succès</h5>*/}
                  {/*        </div>*/}
                  {/*    </div>*/}
                  {/*</div>) : null}*/}
                  <div className={"row"}>
                    <div class="alert alert-warning" role="alert">
                      Importer des factures sous forme d'image est fortement
                      recommandé pour une meilleure précision et extraction des
                      données
                    </div>

                    <div className="col-md-6">
                      <div
                        className={`text-primary bg-primary-transparent card ${
                          importType == "image" ? "selected-card" : ""
                        }`}
                        onClick={() => setImportType("image")}
                      >
                        <button className="btn btn-primary btn-lg">
                          <span className="fe fe-image"> </span>
                          {t("Image")}
                        </button>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className={`text-info bg-info-transparent card ${
                          importType == "pdf" ? "selected-card" : ""
                        }`}
                        onClick={() => setImportType("pdf")}
                      >
                        <button className="btn btn-secondary btn-lg">
                          <span className="fe fe-file"> </span>
                          {t("PDF")}
                        </button>
                      </div>
                    </div>
                  </div>

                  {importType == "image" ? (
                    <>
                      <div className={"row"}>
                        <br />
                        <h1 className={"text-info"}>{t("Type Facture")} *</h1>
                        <div className={"form-group"}>
                          <input
                            id={"achat"}
                            type={"radio"}
                            name={"inv_type"}
                            value={"achat"}
                            checked={invType == "achat" ? true : false}
                            onChange={() => setInvType("achat")}
                          />
                          <label htmlFor={"achat"}>
                            Facture d'achat/Dépense
                          </label>
                        </div>
                        <div className={"form-group"}>
                          <input
                            id={"vente"}
                            type={"radio"}
                            name={"inv_type"}
                            value={"vente"}
                            checked={invType == "vente" ? true : false}
                            onChange={() => setInvType("vente")}
                          />
                          <label htmlFor={"vente"}>Facture de vente</label>
                        </div>
                      </div>
                      <div className={"row"}>
                        <div className="col-md-12">
                          <label className={"text-danger"}>
                            Taille maximale de 2 Mo
                          </label>
                          <input
                            className="form-control form-control-lg"
                            type="file"
                            accept={"image/png, image/jpg, image/jpeg"}
                            onChange={onFileUploadImage}
                          />
                        </div>
                      </div>
                      <div className={"row mt-1"}>
                        <div className={"col-md-12"}>
                          {selectedImageInv ? (
                            <div>
                              <img
                                src={URL.createObjectURL(selectedImageInv)}
                                width="100%"
                              />
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </>
                  ) : importType == "pdf" ? (
                    <>
                      {/*<div class="text-secondary bg-secondary-transparent card"
                                                onClick={convertPdfToImage}
                                            >
                                                <div class="card-body"><h5 class="card-title text-center">{t("coming soon")}</h5></div>
                                            </div>*/}
                      <div className={"row"}>
                        <h1 className={"text-info"}>{t("Type Facture")} *</h1>
                        <br />
                        <div className={"form-group"}>
                          <input
                            id={"achat"}
                            type={"radio"}
                            name={"inv_type"}
                            value={"achat"}
                            checked={invType == "achat" ? true : false}
                            onChange={() => setInvType("achat")}
                          />
                          <label htmlFor={"achat"}>
                            Facture d'achat/Dépense
                          </label>
                        </div>
                        <div className={"form-group"}>
                          <input
                            id={"vente"}
                            type={"radio"}
                            name={"inv_type"}
                            value={"vente"}
                            checked={invType == "vente" ? true : false}
                            onChange={() => setInvType("vente")}
                          />
                          <label htmlFor={"vente"}>Facture de vente</label>
                        </div>
                      </div>
                      <PagePDF
                        typeee={invType}
                        handleSavePdf={handleSavePdf}
                        afterSave={afterPdfSave}
                        save={sevePdf}
                        org_id={organisation?.id}
                        clear={clearPdf}
                        handleClear={handleClear}
                      />
                    </>
                  ) : null}
                </div>
                <div className={"col-md-3"}></div>
              </div>

              <div></div>
            </div>
            <div className={"modal-footer"}>
              <div className={"d-flex flex-row-reverse"}>
                {importType == "image" ? (
                  <button
                    disabled={isSubmitToSave}
                    type="button"
                    className="btn btn-primary"
                    onClick={uploadInv}
                  >
                    {isSubmitToSave ? t("Uploading ...") : t("Enregistrer")}
                  </button>
                ) : importType == "pdf" ? (
                  <button
                    disabled={sevePdf}
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setSavePdf(true)}
                  >
                    {sevePdf ? t("Uploading ...") : t("Enregistrer")}
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="ImportRlvModal"
        tabIndex="-1"
        data-bs-backdrop="static"
        aria-hidden="true"
        aria-labelledby="staticBackdropLabel"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content" style={{ height: "85vh" }}>
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="newClientModal">
                {t("Importer votre relevé bancaire ")}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={initDataUpload}
              >
                <i class="fe fe-x"></i>
              </button>
            </div>
            <div className="modal-body" style={{ overflowY: "auto" }}>
              <div className="row">
                <div className={"col-md-3"}></div>
                <div className={"col-md-6"}>
                  {hasErrorUpload ? (
                    <div className={"row"}>
                      <div className={`text-danger bg-danger-transparent card`}>
                        <div className="card-body">
                          <h5 className="card-title text-center">
                            {errorUpload}
                          </h5>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className={"row"}>
                    <div class="alert alert-warning" role="alert">
                      Importer des Relevé sous forme d'image est fortement
                      recommandé pour une meilleure précision et extraction des
                      données
                    </div>

                    <div className="col-md-6">
                      <div
                        className={`text-primary bg-primary-transparent card ${
                          importType == "image" ? "selected-card" : ""
                        }`}
                        onClick={() => setImportType("image")}
                      >
                        <button className="btn btn-primary btn-lg">
                          <span className="fe fe-image"> </span>
                          {t("Image")}
                        </button>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className={`text-info bg-info-transparent card ${
                          importType == "pdf" ? "selected-card" : ""
                        }`}
                        onClick={() => {
                          setImportType("pdf");
                          setInvType("rlv");
                        }}
                      >
                        <button className="btn btn-secondary btn-lg">
                          <span className="fe fe-file"> </span>
                          {t("PDF")}
                        </button>
                      </div>
                    </div>
                  </div>

                  {importType == "image" ? (
                    <>
                      <div className={"row"}>
                        <div className="col-md-12">
                          <label className={"text-danger"}>
                            Taille maximale de 2 Mo
                          </label>
                          <input
                            className="form-control form-control-lg"
                            type="file"
                            accept={"image/png, image/jpg, image/jpeg"}
                            onChange={onFileUploadImageRlv}
                          />
                        </div>
                      </div>
                      <div className={"row mt-1"}>
                        <div className={"col-md-12"}>
                          {selectedImageRlv ? (
                            <div>
                              <img
                                src={URL.createObjectURL(selectedImageRlv)}
                                width="100%"
                              />
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </>
                  ) : importType == "pdf" ? (
                    <>
                      <PagePDF
                        typeee={invType}
                        handleSavePdf={handleSavePdf}
                        afterSave={afterPdfSave}
                        save={sevePdf}
                        org_id={organisation?.id}
                        clear={clearPdf}
                        handleClear={handleClear}
                      />
                    </>
                  ) : null}
                </div>
                <div className={"col-md-3"}></div>
              </div>

              <div></div>
            </div>
            <div className={"modal-footer"}>
              <div className={"d-flex flex-row-reverse"}>
                {importType == "image" ? (
                  <button
                    disabled={isSubmitToSave}
                    type="button"
                    className="btn btn-primary"
                    onClick={uploadRlv}
                  >
                    {isSubmitToSave ? t("Uploading ...") : t("Enregistrer")}
                  </button>
                ) : importType == "pdf" ? (
                  <button
                    disabled={sevePdf}
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setSavePdf(true)}
                  >
                    {sevePdf ? t("Uploading ...") : t("Enregistrer")}
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row" style={{ zIndex: 1 }}>
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header container-fluid row">
              <div className="col-md-7 col-sm-12 card-title">
                {t("Brouillon de factures et des relevé bancaire numérisées")}
              </div>
              <div className={"col-md-5 col-sm-12"}>
                <div className={"d-flex flex-row-reverse "}>
                  <button
                    className={"btn btn-primary"}
                    data-bs-toggle="modal"
                    data-bs-target="#ImportInvModal"
                    onClick={() => {
                      $(".modal-backdrop").css({
                        "background-color": "",
                        display: "block",
                      });
                    }}
                  >
                    <i className={"fe fe-upload"}></i>{" "}
                    {t("Importer votre facture.")}
                  </button>
                  <button
                    className={"btn btn-primary me-2"}
                    data-bs-toggle="modal"
                    data-bs-target="#ImportRlvModal"
                    onClick={() => {
                      $(".modal-backdrop").css({
                        "background-color": "",
                        display: "block",
                      });
                    }}
                  >
                    <i className={"fe fe-upload"}></i>{" "}
                    {t("Importer votre relevé bancaire.")}
                  </button>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div
                className="modal fade"
                id="staticBackdrop"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h1 className="modal-title fs-5" id="staticBackdropLabel">
                        Facture numérisée
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      {img_preview ? (
                        <img
                          src={`${baseURL.replace(
                            "/api",
                            ""
                          )}/draft/${img_preview}`}
                          width="100%"
                        />
                      ) : null}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          window.$("#staticBackdrop").modal("hide");
                        }}
                      >
                        Fermer
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <div style={{ height: 600, width: "100%" }}>
                  <DataGrid
                    rows={[
                      ...(Array.isArray(rlvs) ? rlvs : [rlvs]),
                      ...invoices,
                    ]}
                    columns={columns}
                    // pagination={false}
                    checkboxSelection
                    localeText={
                      i18n.language == "fr"
                        ? frFR.components.MuiDataGrid.defaultProps.localeText
                        : enUS.components.MuiDataGrid.defaultProps.localeText
                    }
                    slotProps={{
                      toolbar: {
                        printOptions: { disableToolbarButton: true },
                        csvOptions: { disableToolbarButton: true },
                      },
                    }}
                    slots={{
                      toolbar: GridToolbar,
                      loadingOverlay: LinearProgress,
                    }}
                    loading={loadingData}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className={"row"}>
            <div className="col-md-4 row">
              <div className="col-sm-4">
                <img src={MobileScreen} width={150} />
              </div>
              <div className="col-sm-8">
                <h4>El Manager Mobile</h4>
                <p>
                  <strong>El Manager Mobile</strong> est une application mobile
                  disponible sur android, qui vous permet de consulter et
                  scanner vos factures pour le traitement ocr.
                </p>
              </div>
            </div>
            <div className="col-md-8 d-flex flex-row-reverse">
              <div>
                <h5>Téléchargez-le à partir de :</h5>
                <p className={"d-flex flex-row-reverse"}>
                  <img
                    width={180}
                    height={180}
                    src={host + "/apk/qrcode/elmanager-mobile.png"}
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="fullscreenmodal"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-fullscreen" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <span style={{ fontSize: 20 }}>Traitement de la facture</span>
              </h5>
            </div>
            <div className="modal-body">
              {invoice ? (
                <div className="row" style={{ height: "100%" }}>
                  {!processingLoad ? (
                    <div className="col-md-8">
                      {dataProcessing ? (
                        <>
                          <div className="row">
                            <div className="col-md-4">
                              <Steps
                                current={step}
                                vertical
                                style={{
                                  width: "200px",
                                  display: "inline-table",
                                  verticalAlign: "top",
                                  paddingRight: 10,
                                }}
                              >
                                <Steps.Item
                                  onClick={() => {
                                    //setStep(0)
                                  }}
                                  title="Extraction"
                                />
                                <Steps.Item
                                  onClick={() => {
                                    //setStep(1)
                                  }}
                                  title={
                                    invoice?.type == "vente"
                                      ? "Client"
                                      : "Fournisseur"
                                  }
                                />
                                <Steps.Item
                                  onClick={() => {
                                    //setStep(2)
                                  }}
                                  title={
                                    typeAchat && typeAchat == "depense"
                                      ? "Dépenses"
                                      : "Produits"
                                  }
                                />
                                <Steps.Item
                                  onClick={() => {
                                    //setStep(3)
                                  }}
                                  title="Validation"
                                />
                              </Steps>
                            </div>
                            <div className="col-md-8">
                              {step == 0 ? (
                                <form id="data-invoice">
                                  <div className="form-group">
                                    <label
                                      htmlFor="exampleInputEmail1"
                                      className=""
                                    >
                                      Ice{" "}
                                      {invoice?.type == "achat" ||
                                      invoice?.type == "depense"
                                        ? "Fournisseur"
                                        : "Client"}{" "}
                                      *
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control "
                                      value={ice}
                                      disabled={selectCF}
                                      onChange={(event) => {
                                        setIce(event.target.value);
                                      }}
                                    />
                                    {errors.includes("ice") ? (
                                      <div>
                                        <span className="text-danger">
                                          Le champ ice est obligatoire
                                        </span>
                                      </div>
                                    ) : null}
                                    <div className="form-group">
                                      <label className="custom-control custom-checkbox-md">
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          name="clients"
                                          id="client"
                                          checked={selectCF}
                                          onClick={() => {
                                            setSelectCF(!selectCF);
                                          }}
                                        />
                                        <span class="custom-control-label">
                                          Choisir un{" "}
                                          {invoice?.type == "achat"
                                            ? "fournisseur"
                                            : "client"}
                                          *
                                        </span>
                                      </label>
                                      {selectCF ? (
                                        <Select
                                          options={
                                            invoice?.type == "achat"
                                              ? suppliers
                                              : clients
                                          }
                                          onChange={(choice) => {
                                            if (invoice?.type == "achat") {
                                              console.log("supplier", choice);
                                              setSelectedSupplier(choice);
                                              setClient(choice);
                                              setIce(choice.ice);
                                            } else {
                                              console.log("Client", choice);
                                              setClient(choice);
                                              setIce(choice.ice);
                                            }
                                          }}
                                        />
                                      ) : null}
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label
                                      htmlFor="exampleInputEmail1"
                                      className=""
                                    >
                                      Date de la facture *
                                    </label>
                                    <input
                                      type="date"
                                      className="form-control "
                                      id="invoiceDate"
                                      onChange={(event) => {
                                        setInvoiceDate(event.target.value);
                                      }}
                                      value={invoiceDate}
                                    />
                                    {errors.includes("invoiceDate") ? (
                                      <div>
                                        <span className="text-danger">
                                          Le champ obligatoire
                                        </span>
                                      </div>
                                    ) : null}
                                  </div>
                                  <div className="form-group">
                                    <label
                                      htmlFor="exampleInputEmail1"
                                      className=""
                                    >
                                      La date d'échéance de la facture *
                                    </label>
                                    <input
                                      type="date"
                                      className={`form-control`}
                                      id="invoiceDueDate"
                                      onChange={(event) => {
                                        setInvoiceDueDate(event.target.value);
                                      }}
                                      value={invoiceDueDate}
                                    />
                                    {errors.includes("invoiceDueDate") ? (
                                      <div>
                                        <span className="text-danger">
                                          Le champ obligatoire
                                        </span>
                                      </div>
                                    ) : null}
                                  </div>
                                  <div className="form-group">
                                    <label
                                      htmlFor="exampleInputEmail1"
                                      className=""
                                    >
                                      Sous-total HT *
                                    </label>
                                    <div className="input-group">
                                      <input
                                        type="number"
                                        className="form-control "
                                        onChange={(event) => {
                                          setSubtotal(event.target.value);
                                        }}
                                        value={subtotal}
                                      />
                                      <span className="input-group-text">
                                        {organisation?.currency?.code}
                                      </span>
                                    </div>
                                    {errors.includes("subtotal") ? (
                                      <div>
                                        <span className="text-danger">
                                          Le champ obligatoire
                                        </span>
                                      </div>
                                    ) : null}
                                  </div>
                                  <div className="form-group">
                                    <label
                                      htmlFor="exampleInputEmail1"
                                      className=""
                                    >
                                      Total TVA *
                                    </label>
                                    <div className="input-group">
                                      <input
                                        type="number"
                                        className="form-control "
                                        id="invoiceTvaDate"
                                        onChange={(event) => {
                                          setTva(event.target.value);
                                        }}
                                        value={tva}
                                      />
                                      <span className="input-group-text">
                                        {organisation?.currency?.code}
                                      </span>
                                    </div>
                                    {errors.includes("tva") ? (
                                      <div>
                                        <span className="text-danger">
                                          Le champ obligatoire
                                        </span>
                                      </div>
                                    ) : null}
                                  </div>
                                  <div className="form-group">
                                    <label
                                      htmlFor="exampleInputEmail1"
                                      className=""
                                    >
                                      Total TTC *
                                    </label>
                                    <div className="input-group">
                                      <input
                                        type="number"
                                        className="form-control "
                                        onChange={(event) => {
                                          setTotal(event.target.value);
                                        }}
                                        value={total}
                                      />
                                      <span className="input-group-text">
                                        {organisation?.currency?.code}
                                      </span>
                                    </div>
                                    {errors.includes("total") ? (
                                      <div>
                                        <span className="text-danger">
                                          Le champ obligatoire
                                        </span>
                                      </div>
                                    ) : null}
                                    {errors.includes("equal_ttc") ? (
                                      <div>
                                        <span className="text-danger">
                                          le total TVA et le sous-total doivent
                                          être égaux au Total
                                        </span>
                                      </div>
                                    ) : null}
                                  </div>
                                  <div className="form-group">
                                    <label
                                      htmlFor="exampleInputEmail1"
                                      className=""
                                    >
                                      Titre *
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control "
                                      onChange={(event) => {
                                        setTitleInvoice(event.target.value);
                                      }}
                                      value={titleInvoice}
                                    />
                                    {errors.includes("titleInvoice") ? (
                                      <div>
                                        <span className="text-danger">
                                          Le champ obligatoire
                                        </span>
                                      </div>
                                    ) : null}
                                  </div>
                                  {/* ///////////////////////////////// */}
                                  <div className="form-group">
                                    <label
                                      htmlFor="exampleInputEmail1"
                                      className=""
                                    >
                                      N° de la facture * (
                                      {t(
                                        "ce numéro servira de référence pour votre facture originale"
                                      )}
                                      )
                                    </label>
                                    <input
                                      type="text"
                                      placeholder="Fac-0001"
                                      className={`form-control `}
                                      onChange={(e) => {
                                        setInvoiceNumber(e.target.value);
                                        let numExist = invoicesNums.findIndex(
                                          (c) =>
                                            e.target.value ==
                                              c?.invoice_number ||
                                            e.target.value ==
                                              (c.is_custom_invoice_number == 1
                                                ? c.invoice_number
                                                : `Fact-achat-${formatNumber(
                                                    c?.invoice_number
                                                  )}`)
                                        );
                                        if (numExist != -1) {
                                          setExitNum(true);
                                        } else {
                                          setExitNum(false);
                                        }
                                      }}
                                      value={invoiceNumber}
                                      id={"invoiceNumberInput"}
                                    />
                                    {!autoIncrementInvoiceNumber && numExist ? (
                                      <span className={"text-danger"}>
                                        {t("Ce numéro de facture existe déjà")}
                                      </span>
                                    ) : null}
                                    <label className="custom-control custom-checkbox-md">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        name="example-checkbox5"
                                        value="option5"
                                        checked={autoIncrementInvoiceNumber}
                                        onClick={() =>
                                          setAutoIncrementInvoiceNumber(
                                            !autoIncrementInvoiceNumber
                                          )
                                        }
                                        onChange={(e) => {
                                          handleAutoIncrementInvoiceNumber();
                                        }}
                                      />
                                      <span class="custom-control-label">
                                        Utiliser le numéro de facture
                                        auto-incrementer
                                      </span>
                                    </label>
                                  </div>

                                  {/* ///////////////////////////////// */}
                                  {invoice?.type == "achat" ? (
                                    <div className="form-group">
                                      <label
                                        htmlFor="exampleInputEmail1"
                                        className=""
                                      >
                                        Type de facture *
                                      </label>
                                      <select
                                        value={typeAchat}
                                        className={"form-control"}
                                        onChange={(event) => {
                                          setTypeAchat(event.target.value);
                                        }}
                                      >
                                        <option value={0}>_____________</option>
                                        <option value={"achat"}>
                                          Facture lié au stock
                                        </option>
                                        <option value={"depense"}>
                                          Facture de dépense
                                        </option>
                                      </select>
                                      {errors.includes("typeAchat") ? (
                                        <div>
                                          <span className="text-danger">
                                            Le champ obligatoire
                                          </span>
                                        </div>
                                      ) : null}
                                    </div>
                                  ) : null}
                                  <div className="form-group">
                                    <label
                                      htmlFor="exampleInputEmail1"
                                      className=""
                                    >
                                      Statut *
                                    </label>
                                    <select
                                      value={selectedStatus}
                                      className={"form-control"}
                                      onChange={(event) => {
                                        setSelectedStatus(event.target.value);
                                      }}
                                    >
                                      <option value={0}>_____________</option>
                                      {statuses.map((s) => (
                                        <option value={s.id}>{s.name}</option>
                                      ))}
                                    </select>
                                    {errors.includes("selectedStatus") ? (
                                      <div>
                                        <span className="text-danger">
                                          Le champ obligatoire
                                        </span>
                                      </div>
                                    ) : null}
                                  </div>
                                  <div
                                    className="paymentSection"
                                    style={{
                                      display:
                                        selectedStatus === "2" ||
                                        selectedStatus === "3"
                                          ? "block"
                                          : "none",
                                    }}
                                  >
                                    <div className="form-group">
                                      <label
                                        htmlFor="exampleInputEmail1"
                                        className=""
                                      >
                                        Date de règlement*
                                      </label>
                                      <input
                                        type="date"
                                        placeholder="nom"
                                        className={`form-control `}
                                        onChange={(e) =>
                                          setInvoiceStatusCreatedAt(
                                            e.target.value
                                          )
                                        }
                                        value={invoiceStatusCreatedAt}
                                      />
                                    </div>
                                    <div className="form-group">
                                      <label
                                        htmlFor="exampleInputEmail1"
                                        className=""
                                      >
                                        Mode de règlement *
                                      </label>
                                      <select
                                        className="form-select"
                                        id="buyPriceAccountInput"
                                        onChange={(e) => {
                                          setPaymentType(e.target.value);
                                          console.log(
                                            "paymùslkdnb;s,:",
                                            e.target.value
                                          );
                                        }}
                                        value={paymentType}
                                      >
                                        <option value="0">
                                          selectionner un mode de réglement
                                        </option>
                                        {banqueAccounts.map((account) => (
                                          <option
                                            value={account.id}
                                            onClick={() =>
                                              console.log("ffdfdfd")
                                            }
                                          >
                                            {account.code +
                                              " - " +
                                              account.name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>

                                    <div
                                      className="form-group"
                                      style={{
                                        display:
                                          paymentType === "" + bqAccountId + ""
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      <label htmlFor="sousCompte" className="">
                                        Sous Compte*
                                      </label>
                                      <select
                                        className="form-select"
                                        id="sousCompte"
                                        onChange={(e) => {
                                          setSousCompte(e.target.value);
                                        }}
                                        value={sousCompte}
                                      >
                                        <option value="0">
                                          selectionner un sous compte
                                        </option>
                                        {sousComptes.map((account) => (
                                          <option value={account.id}>
                                            {account.code +
                                              " - " +
                                              account.name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>

                                    <div
                                      className="form-group"
                                      style={{
                                        display:
                                          paymentType ===
                                          "" + caisseAccountId + ""
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      <label htmlFor="sousCompte" className="">
                                        Sous Compte*
                                      </label>
                                      <select
                                        className="form-select"
                                        id="sousCompte"
                                        onChange={(e) => {
                                          setSousCompteCs(e.target.value);
                                        }}
                                        value={sousCompteCs}
                                      >
                                        <option value="0">
                                          selectionner un sous compte
                                        </option>
                                        {sousComptesCs.map((account) => (
                                          <option value={account.id}>
                                            {account.code +
                                              " - " +
                                              account.name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>

                                    <div className="banqueOptions">
                                      <div
                                        className="verementOrChéque"
                                        style={{
                                          display:
                                            paymentType ===
                                            "" + bqAccountId + ""
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        <div className="form-group">
                                          <label
                                            htmlFor="exampleInputEmail1"
                                            className=""
                                          >
                                            Virement ou chéque *
                                          </label>
                                          <select
                                            className="form-select"
                                            id="buyPriceAccountInput"
                                            onChange={(e) =>
                                              setBanquePaymentOption(
                                                e.target.value
                                              )
                                            }
                                            value={banquePaymentOption}
                                          >
                                            <option value="0">
                                              selectionner un mode de réglement
                                            </option>
                                            <option value="virement">
                                              Virement
                                            </option>
                                            <option value="chéque">
                                              Chéque
                                            </option>
                                            <option value="carte bancaire">
                                              Carte Bancaire
                                            </option>
                                            <option value="effet">Effet</option>
                                            <option value="prélévement">
                                              Prélévement
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                      <div
                                        className="libelleIfcheque"
                                        style={{
                                          display:
                                            banquePaymentOption === "chéque"
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        <div className="form-group">
                                          <label
                                            htmlFor="exampleInputEmail1"
                                            className=""
                                          >
                                            Identificateur du chéque *
                                          </label>
                                          <input
                                            type="text"
                                            placeholder=""
                                            className={`form-control `}
                                            onChange={(e) =>
                                              setChequeId(e.target.value)
                                            }
                                            value={chequeId}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="form-group"
                                      style={{
                                        display:
                                          selectedStatus === "3"
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      <label
                                        htmlFor="exampleInputEmail1"
                                        className="mpLabel"
                                      >
                                        Montant payé *
                                      </label>
                                      <input
                                        type="text"
                                        placeholder="Montant"
                                        className={`form-control mpInput`}
                                        onChange={(e) => {
                                          if (e.target.value >= total) {
                                            setPayedAmount(0);
                                            toast.error(
                                              "le mantant payé remplit est supérieur ou égale le total ttc",
                                              {
                                                position: "top-right",
                                                autoClose: 5000,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: false,
                                                draggable: true,
                                                progress: undefined,
                                                theme: "colored",
                                              }
                                            );
                                          } else {
                                            setPayedAmount(e.target.value);
                                          }
                                        }}
                                        value={payedAmount}
                                      />
                                    </div>
                                  </div>
                                </form>
                              ) : null}
                              {step == 1 ? (
                                client ? (
                                  <div className="card-body">
                                    <h5 className="card-title">
                                      Infomations du{" "}
                                      {invoice?.type == "achat" ||
                                      invoice?.type == "depense"
                                        ? "Fournisseur"
                                        : "Client"}
                                    </h5>
                                    <h6 className="card-subtitle mb-2 text-muted">
                                      COMPTE #{client.account}
                                    </h6>
                                    <table className="table">
                                      <tr>
                                        <td>
                                          <strong>
                                            {invoice?.type == "achat" ||
                                            invoice?.type == "depense"
                                              ? "Fournisseur"
                                              : "Client"}
                                            :{" "}
                                          </strong>
                                        </td>
                                        <td>{client.companyName}</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>Ice: </strong>
                                        </td>
                                        <td>{client.ice}</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>Tel: </strong>
                                        </td>
                                        <td>{client.phoneNumber}</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>Email: </strong>
                                        </td>
                                        <td>{client.email}</td>
                                      </tr>
                                    </table>
                                  </div>
                                ) : (
                                  <div>
                                    <h4>
                                      <strong>
                                        Ajouter un nouveau{" "}
                                        {invoice?.type == "achat" ||
                                        invoice?.type == "depense"
                                          ? "Fournisseur"
                                          : "Client"}
                                      </strong>
                                    </h4>
                                    <br />
                                    {errors.includes("client") ? (
                                      <div>
                                        <span className="text-danger">
                                          Ajouter d'abord un{" "}
                                          {invoice?.type == "achat" ||
                                          invoice?.type == "depense"
                                            ? "Fournisseur"
                                            : "Client"}
                                        </span>
                                      </div>
                                    ) : null}
                                    <br />
                                    <div
                                      style={{
                                        height: 400,
                                        overflow: "scroll",
                                        overflowX: "hidden",
                                      }}
                                    >
                                      <Client
                                        afterSave={afterSave}
                                        ice={ice}
                                        ocr={true}
                                        type={
                                          invoice.type == "vente"
                                            ? "client"
                                            : "fournisseurs"
                                        }
                                      />
                                    </div>
                                  </div>
                                )
                              ) : null}
                              {step == 2 ? (
                                invoice?.type == "achat" ? (
                                  typeAchat == "depense" ? (
                                    <div>
                                      <div className="col-12">
                                        <div className="card">
                                          <div className="card-header">
                                            <h3 className="card-title">
                                              Dépenses
                                            </h3>
                                          </div>
                                          <div className="card-body">
                                            {errors.includes("depenses") ? (
                                              <div>
                                                <span className="text-danger">
                                                  Ajouter des dépenses
                                                </span>
                                              </div>
                                            ) : null}
                                            {errors.includes("pr_equal_ttc") ? (
                                              <div>
                                                <span className="text-danger">
                                                  le total TVA et le sous-total
                                                  doivent être égaux au Total
                                                </span>
                                              </div>
                                            ) : null}
                                            <button
                                              className="btn btn-primary mb-4"
                                              onClick={() => {
                                                setIsEdit(false);
                                                window
                                                  .$("#modalAddDepense")
                                                  .modal("show");
                                              }}
                                            >
                                              {" "}
                                              Ajouter une dépense
                                            </button>
                                            <div
                                              className="table-responsive"
                                              style={{
                                                height: 270,
                                                overflow: "scroll",
                                                overflowX: "scroll",
                                              }}
                                            >
                                              <table className="table">
                                                <thead>
                                                  <tr>
                                                    <th>Designation</th>
                                                    <th>Compte de dépenses</th>
                                                    <th>Taxe</th>
                                                    <th>Total HT</th>
                                                    <th>Total TTC</th>
                                                    <th></th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {invoicesDepenses.map(
                                                    (depense) => (
                                                      <tr key={depense.id}>
                                                        <td>
                                                          {depense?.designation}
                                                        </td>
                                                        <td>
                                                          {
                                                            depense?.account_name
                                                          }
                                                        </td>
                                                        <td>
                                                          {depense?.taxe_name}
                                                        </td>
                                                        <td>
                                                          {Number(
                                                            depense?.total_ht
                                                          ).toFixed(2)}
                                                        </td>
                                                        <td>
                                                          {Number(
                                                            depense?.total_ttc
                                                          ).toFixed(2)}
                                                        </td>
                                                        <td className="row">
                                                          <button
                                                            onClick={() => {
                                                              deleteDepense(
                                                                depense?.id
                                                              );
                                                            }}
                                                            type="button"
                                                            className="btn  btn-sm btn-danger"
                                                          >
                                                            <span className="fe fe-trash-2">
                                                              {" "}
                                                            </span>
                                                          </button>
                                                          <button
                                                            onClick={() => {
                                                              editDepense(
                                                                depense?.id
                                                              );
                                                            }}
                                                            type="button"
                                                            className="btn  btn-sm btn-primary"
                                                          >
                                                            <span className="fe fe-edit-2">
                                                              {" "}
                                                            </span>
                                                          </button>
                                                        </td>
                                                      </tr>
                                                    )
                                                  )}
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <AddProducts />
                                  )
                                ) : (
                                  <AddProducts />
                                )
                              ) : null}
                              {step == 3 ? (
                                <div>
                                  <div className="card">
                                    <div className="card-header">
                                      <h3 className="card-title">Résumé</h3>
                                    </div>
                                    <div className="card-body">
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row-reverse",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: 15,
                                            fontWeight: "700",
                                          }}
                                        >
                                          Facture{" "}
                                          <strong>
                                            {invoice?.type == "achat"
                                              ? typeAchat == "achat"
                                                ? "lié au stock"
                                                : "de dépense"
                                              : "De vente"}
                                          </strong>
                                        </span>
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: 15,
                                            fontWeight: "700",
                                          }}
                                        >
                                          Facturer à
                                        </span>
                                        <span style={{ fontSize: 12 }}>
                                          {client.companyName}
                                        </span>
                                        <span style={{ fontSize: 12 }}>
                                          {client.phoneNumber}
                                        </span>
                                        <span style={{ fontSize: 12 }}>
                                          {client.email}
                                        </span>
                                        <span style={{ fontSize: 12 }}>
                                          ICE: {client.ice}
                                        </span>
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row-reverse",
                                          marginBottom: 15,
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <span
                                            style={{
                                              fontSize: 13,
                                              fontWeight: "700",
                                            }}
                                          >
                                            Date de facture{" "}
                                            <strong>
                                              {moment(invoiceDate).format(
                                                "DD/MM/yyyy"
                                              )}
                                            </strong>
                                          </span>
                                          <span
                                            style={{
                                              fontSize: 13,
                                              fontWeight: "700",
                                            }}
                                          >
                                            Date d'échéance{" "}
                                            <strong>
                                              {moment(invoiceDueDate).format(
                                                "DD/MM/yyyy"
                                              )}
                                            </strong>
                                          </span>
                                        </div>
                                      </div>
                                      {typeAchat && typeAchat == "depense" ? (
                                        <div
                                          className="table-responsive"
                                          style={{
                                            height: 270,
                                            overflow: "scroll",
                                            overflowX: "scroll",
                                          }}
                                        >
                                          <table className="table">
                                            <thead>
                                              <tr>
                                                <th>Designation</th>
                                                <th>Compte de dépenses</th>
                                                <th>Taxe</th>
                                                <th>Total HT</th>
                                                <th>Total TTC</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {invoicesDepenses.map(
                                                (depense) => (
                                                  <tr key={depense.id}>
                                                    <td>
                                                      {depense?.designation}
                                                    </td>
                                                    <td>
                                                      {depense?.account_name}
                                                    </td>
                                                    <td>
                                                      {depense?.taxe_name}
                                                    </td>
                                                    <td>{depense?.total_ht}</td>
                                                    <td>
                                                      {depense?.total_ttc}
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      ) : (
                                        <div
                                          style={{
                                            overflowX: "auto",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          <table className="table text-nowrap text-md-nowrap mb-0">
                                            <thead>
                                              <tr>
                                                <th>Nom d'article</th>
                                                <th>Prix</th>
                                                <th>Quantité</th>
                                                <th>Total TTC</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {invoice_products.map(
                                                (product) => (
                                                  <tr>
                                                    <td>{product?.name}</td>
                                                    <td>
                                                      {Number(
                                                        product?.price_unit_ht
                                                      ).toFixed(2)}
                                                    </td>
                                                    <td>{product?.quantity}</td>
                                                    <td>
                                                      {Number(
                                                        product?.total_ttc
                                                      ).toFixed(2)}
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      )}
                                      <div
                                        style={{
                                          marginTop: 25,
                                          display: "flex",
                                          flexDirection: "row-reverse",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            marginBottom: 15,
                                          }}
                                        >
                                          <span>
                                            Sous-Total HT:{" "}
                                            <span
                                              style={{
                                                fontSize: 15,
                                                fontWeight: "700",
                                              }}
                                            >
                                              <strong>
                                                {Number(subtotal).toFixed(2)}
                                              </strong>
                                            </span>{" "}
                                            {organisation?.currency?.code}
                                          </span>
                                          <span>
                                            Total TVA:{" "}
                                            <span
                                              style={{
                                                fontSize: 15,
                                                fontWeight: "700",
                                              }}
                                            >
                                              {" "}
                                              <strong>
                                                {Number(tva).toFixed(2)}
                                              </strong>
                                            </span>{" "}
                                            {organisation?.currency?.code}
                                          </span>
                                          <span>
                                            Total TTC:{" "}
                                            <span
                                              style={{
                                                fontSize: 15,
                                                fontWeight: "700",
                                              }}
                                            >
                                              {" "}
                                              <strong>
                                                {Number(total).toFixed(2)}
                                              </strong>{" "}
                                            </span>
                                            {organisation?.currency?.code}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                              <hr />
                              <ButtonGroup>
                                <Button
                                  onClick={onPrevious}
                                  disabled={step === 0}
                                >
                                  Précédent
                                </Button>
                                <Button onClick={onNext} disabled={step === 3}>
                                  Suivant
                                </Button>
                              </ButtonGroup>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="alert alert-danger" role="alert">
                          Erreur lors du traitement de votre facture, veuillez
                          réessayer
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="col-md-8">
                      <span>Traitement ...</span>
                      <div className="progress progress-md mb-3">
                        <div className="progress-bar progress-bar-indeterminate bg-blue-1"></div>
                      </div>
                    </div>
                  )}
                  <div
                    className="col-md-4"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      borderLeft: "solid",
                      borderLeftWidth: "0.5px",
                      borderLeftColor: "darkgrey",
                    }}
                  >
                    <h4>Facture</h4>
                    <figure>
                      <Zoom>
                        <img
                          id="previewInvoice"
                          src={`${baseURL.replace("/api", "")}/draft/${
                            invoice?.file
                          }`}
                          width="90%"
                        />
                      </Zoom>
                    </figure>
                  </div>
                </div>
              ) : null}
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-default"
                onClick={() => {
                  window.$("#modalCloseOcr").modal("show");
                }}
              >
                Fermer
              </button>
              <button
                onClick={save}
                disabled={step == 3 || loadingSa ? false : true}
                className="btn btn-primary"
              >
                {loadingSa ? "Chargement" : "Sauvegarder"}
              </button>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="modalAddProduct"
          tabIndex="-1"
          style={{ display: "none" }}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg " role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Selection un produit</h5>
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModalAddProduct}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <div className={"d-flex flex-row-reverse"}>
                      <button
                        className={"btn text-primary"}
                        onClick={() => {
                          window.$("#modalNewAddProduct").modal("show");
                        }}
                      >
                        <i className={"fa fa-plus"}> Nouveau</i>
                      </button>
                    </div>

                    <label>Produit *</label>
                    <select
                      ref={selectProd}
                      className={"form-control"}
                      value={selectProduct?.id || 0} // Utilisation de l'opérateur de chaînage optionnel
                      onChange={(event) => {
                        // Réinitialisation des champs à la sélection d'un nouveau produit
                        // inputTotalTcc.current.value = null;
                        // inputQuantity.current.value = null;
                        setQty(1);
                        setTotalTTC(0);
                        setPrixUn(0);

                        const id = event.target.value;
                        if (id && id != 0) {
                          setIsService(false); // Réinitialiser l'état 'isService'

                          // Trouver l'index et le produit correspondant
                          const indexProduct = products.findIndex(
                            (p) => p?.id == id
                          );
                          const product = products[indexProduct];

                          if (product) {
                            // Gestion spécifique aux services
                            if (product?.type === "Services") {
                              inputQuantity.current.value = 1;
                              setIsService(true);
                            } else {
                              inputQuantity.current.value = 0;
                              setIsService(false);
                            }

                            console.log("prd", product);

                            // Mettre à jour l'état avec le produit sélectionné
                            setSelectedProduct(product);

                            // Définir le prix en fonction du type de facture
                            inputPrice.current.value =
                              invoice?.type == "vente"
                                ? product?.sellingPrice
                                : product?.costPrice;

                            // Focaliser sur le champ quantité après sélection
                            // inputQuantity.current.focus();
                          }
                        }
                      }}
                    >
                      <option value={0}>___</option>
                      {products.map((product) => (
                        <option key={product.id} value={product.id}>
                          {product.name} | {product.type}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-4">
                    <label>Prix UT</label>
                    <div className="input-group">
                      <input
                        // disabled={!isService}
                        ref={inputPrice}
                        placeholder="Prix UT"
                        className={"form-control"}
                        type="text"
                        name="prix-ut"
                        // value={prixUn}
                        onChange={(event) => {
                          if (qty > 0) {
                            if (selectProduct) {
                              var price = parseFloat(
                                event.target.value || 0
                              ).toFixed(2);
                              setPrixUn(parseFloat(price));

                              var tva =
                                invoice?.type === "vente"
                                  ? selectProduct?.taxe_vente?.rate || 0
                                  : selectProduct?.taxe_achat?.rate || 0;

                              var totalHT = qty * price;
                              var totalTva = (totalHT * tva) / 100;
                              var ttalTTC = totalHT + totalTva;
                              setTotalTTC(ttalTTC);

                              var prod_with_ttc = { ...selectProduct };
                              prod_with_ttc["price_unit_ht"] =
                                parseFloat(price).toFixed(2);
                              prod_with_ttc["total_ttc"] =
                                parseFloat(ttalTTC).toFixed(2);
                              prod_with_ttc["total_ht"] =
                                parseFloat(totalHT).toFixed(2);
                              prod_with_ttc["quantity"] =
                                parseFloat(qty).toFixed(2);

                              setSelectedProduct(prod_with_ttc);
                              console.log(prod_with_ttc);
                              console.log(selectProduct);
                            }
                          }
                        }}
                      />
                      <span className="input-group-text">
                        {organisation?.currency?.code}
                      </span>
                    </div>
                  </div>
                  <div className="col-4" hidden={isService}>
                    <label>Quantité *</label>
                    <input
                      disabled={!selectProduct}
                      ref={inputQuantity}
                      placeholder="Quantité"
                      className={"form-control"}
                      type="number"
                      // value={qty}
                      name="prix-ut"
                      id="input-qty"
                      onChange={(event) => {
                        var val = parseFloat(event.target.value || 0);
                        setQty(val);

                        if (val > 0) {
                          if (selectProduct) {
                            var tva =
                              invoice?.type === "vente"
                                ? selectProduct?.taxe_vente?.rate || 0
                                : selectProduct?.taxe_achat?.rate || 0;

                            var totalHT = val * prixUn;
                            setTotalHT(totalHT);

                            var totalTva = (totalHT * tva) / 100;
                            var ttalTTC = totalHT + totalTva;
                            setTotalTTC(ttalTTC.toFixed(2));

                            var prod_with_ttc = { ...selectProduct };
                            prod_with_ttc["price_unit_ht"] =
                              parseFloat(prixUn).toFixed(2);
                            prod_with_ttc["total_ttc"] =
                              parseFloat(ttalTTC).toFixed(2);
                            prod_with_ttc["total_ht"] =
                              parseFloat(totalHT).toFixed(2);
                            prod_with_ttc["quantity"] = val.toFixed(2);

                            setSelectedProduct(prod_with_ttc);
                            console.log(prod_with_ttc);
                            console.log(selectProduct);
                          }
                        } else {
                          setTotalTTC(0);
                          setTotalHT(0);
                        }
                      }}
                    />
                  </div>
                  <div className="col-4">
                    <label>Total TTC</label>
                    <div className="input-group">
                      <input
                        disabled={true}
                        // ref={inputTotalTcc}
                        value={totalTTC}
                        placeholder="Total TTC"
                        className={"form-control"}
                        type="text"
                        name="total_ttc"
                      />
                      <span className="input-group-text">
                        {organisation?.currency?.code}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={closeModalAddProduct}
                >
                  Fermer
                </button>
                <button
                  disabled={!selectProduct}
                  className="btn btn-primary"
                  onClick={() => {
                    if (
                      selectProduct &&
                      parseInt(inputQuantity.current.value) > 0
                    ) {
                      var index = invoice_products.findIndex(
                        (p) => p?.id == selectProduct?.id
                      );
                      if (index > -1) {
                        let prev_invoice_products = invoice_products;
                        prev_invoice_products[index] = selectProduct;
                        setInvoiceProducts(prev_invoice_products);
                      } else {
                        setInvoiceProducts([
                          ...invoice_products,
                          selectProduct,
                        ]);
                      }

                      closeModalAddProduct();
                    } else {
                      window
                        .$("#input-qty")
                        .addClass("is-invalid state-invalid");
                    }
                  }}
                >
                  Ajouter
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="modalNewAddProduct"
          tabIndex="-1"
          style={{ display: "none", backgroundColor: "#0000001f" }}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg " role="document">
            <div
              className="modal-content"
              style={{ maxHeight: "90vh", overflowY: "auto" }}
            >
              <div className="modal-header">
                <h5 className="modal-title">Ajouter un nouveau produit</h5>
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    window.$("#modalNewAddProduct").modal("hide");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <NewItems in_popup={true} onSave={onSaveNewProduct} />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    window.$("#modalNewAddProduct").modal("hide");
                  }}
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="modalAddDepense"
          tabIndex="-1"
          style={{ display: "none" }}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg " role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Ajouter un compte de dépense</h5>
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModalAddDepense}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <label htmlFor="validationTooltip02">DESIGNATION *</label>
                    <textarea
                      value={designationAcc}
                      ref={ref_desg}
                      className={`form-control `}
                      onChange={(e) => setDesignationAcc(e.target.value)}
                    ></textarea>
                  </div>
                  <br />
                  <div className="col-12">
                    <label>COMPTE DE DEPENSE *</label>
                    <select
                      value={Acc.id}
                      className={"form-control"}
                      onChange={(event) => {
                        let id = event.target.value;
                        if (id && id != 0) {
                          var indexAccount = purchaseAccounts.findIndex(
                            (p) => p?.id == id
                          );
                          var acc = purchaseAccounts[indexAccount];
                          if (acc) {
                            setAccount(acc);
                          }
                        }
                      }}
                    >
                      <option value={0}>_____________</option>
                      {purchaseAccounts.map((account_p) => (
                        <option value={account_p.id}>
                          {account_p.code} - {account_p.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-6">
                    <label>TVA *</label>
                    <select
                      value={taxeAcc.id}
                      className={"form-control"}
                      onChange={(event) => {
                        let id = event.target.value;
                        if (id && id != 0) {
                          var indexTaxe = taxes.findIndex((p) => p?.id == id);
                          var tx = taxes[indexTaxe];
                          if (tx) {
                            setTaxeAcc(tx);
                          }
                        }
                      }}
                    >
                      <option value={0}>_____________</option>
                      {taxes.map((tx) => (
                        <option value={tx.id}>{tx.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-6">
                    <label>Total HT *</label>
                    <div className="input-group">
                      <input
                        value={totalDepenseAcc}
                        placeholder="Total HT"
                        className={"form-control"}
                        type="number"
                        onChange={(event) => {
                          let tl = parseFloat(event.target.value);
                          if (!isNaN(tl)) {
                            setTotalDepenseAcc(tl);
                          } else {
                            setTotalDepenseAcc("0"); // Valeur par défaut si la conversion échoue
                          }
                        }}
                      />
                      <span className="input-group-text">
                        {organisation?.currency?.code}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={closeModalAddDepense}
                >
                  Fermer
                </button>
                <button
                  disabled={
                    !(
                      designationAcc &&
                      designationAcc != "" &&
                      Acc &&
                      Acc.id != 0 &&
                      taxeAcc &&
                      taxeAcc.id != 0 &&
                      totalDepenseAcc &&
                      totalDepenseAcc != 0
                    )
                  }
                  className="btn btn-primary"
                  onClick={() => {
                    if (!isEdit) {
                      // Adding a new expense
                      if (
                        designationAcc &&
                        designationAcc !== "" &&
                        Acc &&
                        Acc.id !== 0 &&
                        taxeAcc &&
                        taxeAcc.id !== 0 &&
                        totalDepenseAcc &&
                        totalDepenseAcc !== 0
                      ) {
                        let id = (Math.random() + 1).toString(36).substring(7);
                        let singleSpentAccountElt = {
                          id: id,
                          account_id: Acc?.id,
                          account_name: Acc?.name,
                          taxe_id: taxeAcc?.id,
                          taxe_name: taxeAcc?.name,
                          rate: taxeAcc?.rate,
                          total_ht: totalDepenseAcc.toFixed(2),
                          total_ttc: (
                            parseFloat(totalDepenseAcc) +
                            (parseFloat(totalDepenseAcc) *
                              parseFloat(taxeAcc?.rate)) /
                              100
                          ).toFixed(2),
                          designation: designationAcc,
                        };
                        setInvoicesDepenses([
                          ...invoicesDepenses,
                          singleSpentAccountElt,
                        ]);
                        closeModalAddDepense();
                      } else {
                        alert("Ajouter des valeurs !!");
                      }
                    } else {
                      // Editing an existing expense
                      if (
                        designationAcc &&
                        designationAcc !== "" &&
                        Acc &&
                        Acc.id !== 0 &&
                        taxeAcc &&
                        taxeAcc.id !== 0 &&
                        totalDepenseAcc &&
                        totalDepenseAcc !== 0
                      ) {
                        let updatedInvoices = invoicesDepenses.map((depense) =>
                          depense.id === productEdit[0].id
                            ? {
                                id: productEdit[0].id,
                                account_id: Acc?.id,
                                account_name: Acc?.name,
                                taxe_id: taxeAcc?.id,
                                taxe_name: taxeAcc?.name,
                                rate: taxeAcc?.rate,
                                total_ht: totalDepenseAcc.toFixed(2),
                                total_ttc: (
                                  parseFloat(totalDepenseAcc) +
                                  (parseFloat(totalDepenseAcc) *
                                    parseFloat(taxeAcc?.rate)) /
                                    100
                                ).toFixed(2),
                                designation: designationAcc,
                              }
                            : depense
                        );
                        setInvoicesDepenses(updatedInvoices);
                        closeModalAddDepense();
                      } else {
                        alert("Ajouter des valeurs !!");
                      }
                    }
                  }}
                >
                  Ajouter
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="modalCloseOcr"
          style={{ display: "none" }}
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered text-center"
            role="document"
          >
            <div className="modal-content tx-size-sm">
              <div className="modal-body text-center p-4 pb-5">
                <button
                  aria-label="Close"
                  className="btn-close position-absolute"
                  data-bs-dismiss="modal"
                >
                  <span aria-hidden="true">×</span>
                </button>
                <i className="icon icon-close fs-70 text-danger lh-1 my-5 d-inline-block"></i>
                <h4 className="text-danger">{t("Are you sure?")}</h4>
                <p className="mg-b-20 mg-x-20">
                  {t(
                    "Êtes-vous sûr de vouloir fermer cette fenêtre ? Toutes vos données sont perdues"
                  )}
                </p>
                <button
                  onClick={() => {
                    initData();
                    window.$("#modalCloseOcr").modal("hide");
                    window.$("#fullscreenmodal").modal("hide");
                  }}
                  aria-label="Close"
                  className="btn btn-danger pd-x-25"
                  data-bs-dismiss="modal"
                >
                  Oui Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="fullscreenmodalRLV"
        tabIndex="-1"
        role="dialog"
      >
        <ToastContainer />
        <div className="modal-dialog modal-fullscreen" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <span
                  className="badge rounded-pill bg-warning badge-sm me-1 mb-1 mt-1"
                  style={{ fontSize: 20 }}
                >
                  Rapprochement bancaire
                </span>
              </h5>
            </div>
            <div className="modal-body">
              <div className="row" style={{ height: "90%" }}>
                {!processingLoad ? (
                  dataProcessingRlv.length == 0 ? (
                    <div className="col-md-8">
                      <div className="alert alert-danger" role="alert">
                        Erreur lors du traitement de votre Relevé Bancaire,
                        veuillez réessayer
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="col-md-8">
                        {stepRlv === 1 ? (
                          /* debut de step 1 */
                          <div
                            role="alert"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="form-group"
                              style={{ width: "100%" }}
                            >
                              <label htmlFor="date">Date de Releve :</label>
                              <input
                                className="form-control"
                                type="month"
                                name="date"
                                id="d"
                                style={{
                                  width: "100%",
                                  padding: "8px",
                                  margin: "8px 0",
                                  boxSizing: "border-box",
                                }}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const month = value.split("-")[1];
                                  const year = value.split("-")[0];
                                  setDataProcessingRlv((prevData) => {
                                    return prevData.map((data) => {
                                      const day = data.date.split("/")[0];
                                      data.date = `${day}/${month}`;
                                      data.year = year;
                                      return data;
                                    });
                                  });
                                  console.log(dataProcessingRlv);
                                  setDateRlv(value);
                                  //2025-01
                                }}
                              />
                              <label htmlFor="sousCompte">
                                Sous Compte Bancaire :
                              </label>
                              <Select
                                options={sousComptes.map((account) => ({
                                  value: account.id,
                                  label: `${account.code} - ${account.name}`,
                                }))}
                                onChange={(selectedOption) => {
                                  setSouscompteRlvBq(selectedOption.value);
                                  setDataProcessingRlv((prevData) => {
                                    return prevData.map((data) => {
                                      data.operations.forEach((op) => {
                                        if (op.type === "contrePartie") {
                                          op.account = selectedOption.value;
                                        }
                                      });
                                      return data;
                                    });
                                  });
                                  console.log(dataProcessingRlv);
                                }}
                              />
                              <br />
                              <label htmlFor="soldeDpart">Solde Depart :</label>
                              <input
                                className="form-control"
                                type="text"
                                name="soldeDpart"
                                id="soldeDpart"
                                value={soldeDepart}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setSoldeDepart(value)
                                }}
                                onBlur={(e) => {
                                  const value = e.target.value;
                                 setSoldeDepart(parseFloat(value).toFixed(2))
                                }}
                              />
                            </div>
                            {/* fin de step 1 */}
                          </div>
                        ) : (
                          <div role="alert">
                            {/* debut step2 */}
                            <table className="table">
                              <thead className="text-center">
                                <tr className="text-center">
                                  <th>Date</th>
                                  <th>Libellé</th>
                                  <th>Account</th>
                                  <th>Débit</th>
                                  <th>Crédit</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Array.isArray(dataProcessingRlv) &&
                                  dataProcessingRlv.map((data, index) => (
                                    <React.Fragment key={index}>
                                      {/* Ligne principale pour la date et le libellé */}
                                      <tr className="text-center bg-light">
                                        <td>
                                          <span className="text-center">
                                            {getMonthName(
                                              data.date.split("/")[1]
                                            )}
                                          </span>
                                          <input
                                            type="number"
                                            value={data.date.split("/")[0]}
                                            name="dateOpe"
                                            className="form-control text-center"
                                            onChange={(event) => {
                                              setDataProcessingRlv(
                                                (prevData) => {
                                                  const newData = [...prevData];
                                                  const value =
                                                    event.target.value;
                                                  const month =
                                                    newData[index].date.split(
                                                      "/"
                                                    )[1];
                                                  if (value <= 31) {
                                                    newData[
                                                      index
                                                    ].date = `${value}/${month}`;
                                                  } else {
                                                    console.error(
                                                      "Invalid input format. Please enter a date in the format 'YYYY-MM-DD'."
                                                    );
                                                  }
                                                  return newData;
                                                }
                                              );
                                              console.log(dataProcessingRlv);
                                            }}
                                            id="dateOp"
                                          />
                                        </td>
                                        {/* Cellules vide pour alignement */}
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>

                                      {/* Boucle des opérations associées */}
                                      {data.operations.map(
                                        (operation, opIndex) => (
                                          <tr
                                            key={`${index}-${opIndex}`}
                                            className="text-center"
                                          >
                                            <td></td>{" "}
                                            {/* Cellule vide pour alignement */}
                                            {operation.libille !== "    " ? (
                                              <td className="text-center">
                                                <textarea
                                                  type="textarea"
                                                  className="form-control text-center"
                                                  name="opLib"
                                                  id="opLib"
                                                  onChange={(event) => {
                                                    setDataProcessingRlv(
                                                      (prevData) => {
                                                        const newData = [
                                                          ...prevData,
                                                        ];
                                                        newData[
                                                          index
                                                        ].operations[
                                                          opIndex
                                                        ].libille =
                                                          event.target.value;
                                                        return newData;
                                                      }
                                                    );
                                                  }}
                                                >
                                                  {operation.libille}
                                                </textarea>
                                              </td>
                                            ) : (
                                              <td> </td>
                                            )}
                                            <td>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  width: "100%",
                                                }}
                                              >
                                                <select
                                                  style={{ width: "130px" }}
                                                  value={operation.account}
                                                  disabled={
                                                    operation.type ===
                                                    "contrePartie"
                                                  }
                                                  className={"form-control"}
                                                  onChange={(event) => {
                                                    let id = event.target.value;
                                                    if (id && id != 0) {
                                                      var indexAccount =
                                                        purchaseAccounts.findIndex(
                                                          (p) => p?.id == id
                                                        );
                                                      var acc =
                                                        purchaseAccounts[
                                                          indexAccount
                                                        ];
                                                      if (acc) {
                                                        setDataProcessingRlv(
                                                          (prevData) => {
                                                            const newData = [
                                                              ...prevData,
                                                            ];
                                                            newData[
                                                              index
                                                            ].operations[
                                                              opIndex
                                                            ].account = acc.id;
                                                            // setAccount(acc.id);
                                                            return newData;
                                                          }
                                                        );
                                                      }
                                                    }
                                                  }}
                                                >
                                                  <option value={0}>
                                                    _____________
                                                  </option>
                                                  {purchaseAccounts.map(
                                                    (account_p) => (
                                                      <option
                                                        value={account_p.id}
                                                      >
                                                        {account_p.code} -{" "}
                                                        {account_p.name}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </div>
                                            </td>
                                            <td>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                }}
                                              >
                                                <input
                                                  style={{ width: "120px" }}
                                                  className="form-control text-center"
                                                  type="number"
                                                  name="opDebit"
                                                  id="opDebit"
                                                  value={operation.debit}
                                                  onChange={(event) => {
                                                    setDataProcessingRlv(
                                                      (prevData) => {
                                                        const newData = [
                                                          ...prevData,
                                                        ];
                                                        const value =
                                                          event.target.value.replace(
                                                            ",",
                                                            "."
                                                          );

                                                        if (value) {
                                                          newData[
                                                            index
                                                          ].operations[
                                                            opIndex
                                                          ].debit = value;
                                                        } else {
                                                          // Optionally, you can show an error message or handle invalid input
                                                          console.error(
                                                            "Invalid input format. Please enter a number in the format '6000.00'."
                                                          );
                                                        }
                                                        return newData;
                                                      }
                                                    );
                                                  }}
                                                  onBlur={(event) => {
                                                    const value =
                                                      event.target.value;
                                                    if (value) {
                                                      event.target.value =
                                                        parseFloat(
                                                          value
                                                        ).toFixed(2);
                                                      setDataProcessingRlv(
                                                        (prevData) => {
                                                          const newData = [
                                                            ...prevData,
                                                          ];
                                                          newData[
                                                            index
                                                          ].operations[
                                                            opIndex
                                                          ].debit =
                                                            parseFloat(
                                                              value
                                                            ).toFixed(2);
                                                          return newData;
                                                        }
                                                      );
                                                    }
                                                  }}
                                                />
                                              </div>
                                            </td>
                                            <td>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                }}
                                              >
                                                <input
                                                  style={{ width: "120px" }}
                                                  className="form-control text-center"
                                                  type="text"
                                                  name="opCredit"
                                                  id="opCredit"
                                                  value={operation.credit}
                                                  onChange={(event) => {
                                                    setDataProcessingRlv(
                                                      (prevData) => {
                                                        const newData = [
                                                          ...prevData,
                                                        ];
                                                        const value =
                                                          event.target.value;

                                                        if (value) {
                                                          newData[
                                                            index
                                                          ].operations[
                                                            opIndex
                                                          ].credit = value;
                                                        } else {
                                                          console.error(
                                                            "Invalid input format. Please enter a number in the format '6000.00'."
                                                          );
                                                        }
                                                        return newData;
                                                      }
                                                    );
                                                  }}
                                                  onBlur={(event) => {
                                                    const value =
                                                      event.target.value;
                                                    if (value) {
                                                      event.target.value =
                                                        parseFloat(
                                                          value
                                                        ).toFixed(2);
                                                      setDataProcessingRlv(
                                                        (prevData) => {
                                                          const newData = [
                                                            ...prevData,
                                                          ];
                                                          newData[
                                                            index
                                                          ].operations[
                                                            opIndex
                                                          ].credit =
                                                            parseFloat(
                                                              value
                                                            ).toFixed(2);
                                                          return newData;
                                                        }
                                                      );
                                                    }
                                                  }}
                                                />
                                              </div>
                                            </td>
                                            <td>
                                              <button
                                                id="bDel"
                                                type="button"
                                                className="btn  btn-sm btn-danger"
                                                onClick={() => {
                                                  setDataProcessingRlv(
                                                    (prevData) => {
                                                      const newData = [
                                                        ...prevData,
                                                      ];
                                                      newData[
                                                        index
                                                      ].operations.splice(
                                                        opIndex,
                                                        1
                                                      );
                                                      if (
                                                        newData[index]
                                                          .operations.length ==
                                                        0
                                                      ) {
                                                        newData.splice(
                                                          index,
                                                          1
                                                        );
                                                      }
                                                      return newData;
                                                    }
                                                  );
                                                }}
                                              >
                                                <span className="fe fe-trash-2">
                                                  {" "}
                                                </span>
                                              </button>
                                            </td>
                                          </tr>
                                        )
                                      )}

                                      {/* Bouton pour ajouter une ligne */}
                                      <tr>
                                        <td colSpan={7} className="text-center">
                                          <button
                                            className="btn btn-primary"
                                            onClick={() => {
                                              window
                                                .$("#modalNewTrans")
                                                .modal("show");
                                              setIndex(index);
                                              setIsNewOp(false);
                                              console.log(
                                                "Ajouter une transaction"
                                              );
                                            }}
                                          >
                                            Ajouter une transaction
                                          </button>
                                        </td>
                                      </tr>

                                      {/* /* Séparateur */}
                                      <tr>
                                        <td colSpan={6}>
                                          <hr />

                                          <span
                                            className="text-danger"
                                            style={{
                                              fontSize: 19,
                                              fontWeight: "bold",
                                              marginRight: 70,
                                            }}
                                          >
                                            Total Debit :{" "}
                                            {data.operations
                                              .reduce((sum, operation) => {
                                                return (
                                                  sum +
                                                  parseFloat(operation.debit)
                                                );
                                              }, 0)
                                              .toFixed(2)}
                                          </span>
                                          <span
                                            className="text-success"
                                            style={{
                                              fontSize: 19,
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Total Credit :{" "}
                                            {data.operations
                                              .reduce((sum, operation) => {
                                                return (
                                                  sum +
                                                  parseFloat(operation.credit)
                                                );
                                              }, 0)
                                              .toFixed(2)}
                                          </span>
                                        </td>
                                      </tr>
                                    </React.Fragment>
                                  ))}
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td colSpan={7}></td>
                                </tr>
                              </tfoot>
                            </table>

                            {/* fin step2 */}
                          </div>
                        )}
                      </div>

                      {/* debut add operattion modal*/}
                      <div
                        className="modal fade"
                        id="modalNewTrans"
                        tabIndex="-1"
                        style={{ display: "none" }}
                        aria-hidden="true"
                      >
                        <div className="modal-dialog modal-lg " role="document">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title">
                                {isNewOp
                                  ? "Ajouter une operation"
                                  : "Ajouter une transaction"}
                              </h5>
                              <button
                                className="btn-close"
                                data-bs-dismiss="modal"
                              ></button>
                            </div>
                            <div className="modal-body">
                              {isNewOp && (
                                <div className="form-group">
                                  <label htmlFor="date">Jour :</label>
                                  <input
                                    type="number"
                                    name="date"
                                    id="date"
                                    className="form-control"
                                    onChange={(event) => {
                                      const value = event.target.value;
                                      if (value <= 31) {
                                        setDateOp(value);
                                      } else {
                                        setDateOp(1);
                                      }
                                    }}
                                    onBlur={(ev) => {
                                      const value = ev.target.value;
                                      if (value > 31) {
                                        toast.error(
                                          "Veuillez entrer une valeur entre 1 et 31",
                                          {
                                            position: "top-right",
                                            autoClose: 5000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: false,
                                            draggable: true,
                                            progress: undefined,
                                            theme: "colored",
                                          }
                                        );
                                        return;
                                      }
                                    }}
                                  />
                                </div>
                              )}
                              <div className="form-group">
                                <label htmlFor="libelle">Libellé :</label>
                                <input
                                  type="text"
                                  name="libelle"
                                  id="libelle"
                                  value={libelle}
                                  onChange={(event) => {
                                    setLibelle(event.target.value);
                                  }}
                                  className="form-control"
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor="account">Account :</label>
                                <select
                                  value={trAccount}
                                  className={"form-control text-center"}
                                  onChange={(event) => {
                                    let id = event.target.value;
                                    if (id && id != 0) {
                                      var indexAccount =
                                        purchaseAccounts.findIndex(
                                          (p) => p?.id == id
                                        );
                                      var acc = purchaseAccounts[indexAccount];
                                      if (acc) {
                                        setTrAccount(acc.id);
                                      }
                                    }
                                  }}
                                >
                                  <option value={0}>_____________</option>
                                  {purchaseAccounts.map((account_p) => (
                                    <option value={account_p.id}>
                                      {account_p.code} - {account_p.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div
                                className="form-group"
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-around",
                                }}
                              >
                                <div>
                                  <label htmlFor="debit">Débit :</label>
                                  <input
                                    type="number"
                                    name="debit"
                                    id="debit"
                                    value={debit}
                                    className="form-control"
                                    onChange={(event) => {
                                      setDebit(event.target.value);
                                    }}
                                    onBlur={(event) => {
                                      const value = event.target.value;
                                      if (value) {
                                        event.target.value =
                                          parseFloat(value).toFixed(2);
                                        setDebit(parseFloat(value).toFixed(2));
                                      }
                                    }}
                                  />
                                </div>
                                <div>
                                  <label htmlFor="credit">Crédit :</label>
                                  <input
                                    type="number"
                                    name="credit"
                                    id="credit"
                                    value={credit}
                                    className="form-control"
                                    onChange={(event) => {
                                      setCredit(event.target.value);
                                    }}
                                    onBlur={(event) => {
                                      const value = event.target.value;
                                      if (value) {
                                        event.target.value =
                                          parseFloat(value).toFixed(2);
                                        setCredit(parseFloat(value).toFixed(2));
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                  setLibelle("");
                                  setTrAccount(0);
                                  setDebit(0);
                                  setCredit(0);
                                  setIndex();
                                  setIsNewOp(false);
                                }}
                              >
                                Fermer
                              </button>
                              <button
                                className="btn btn-primary"
                                onClick={() => {
                                  console.log("isNewOp", isNewOp);
                                  if (
                                    libelle === "" ||
                                    trAccount === "" ||
                                    (debit === 0 && credit === 0)
                                  ) {
                                    let errorMessage =
                                      "Veuillez remplir tous les champs.";
                                    toast.error(errorMessage, {
                                      position: "top-right",
                                      autoClose: 5000,
                                      hideProgressBar: false,
                                      closeOnClick: true,
                                      pauseOnHover: false,
                                      draggable: true,
                                      progress: undefined,
                                      theme: "colored",
                                    });
                                    return;
                                  }

                                  if (isNewOp == false) {
                                    setDataProcessingRlv((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].operations.push({
                                        libille: libelle,
                                        account: trAccount,
                                        debit: debit,
                                        credit: credit,
                                        type: "initial",
                                      });
                                      return newData;
                                    });
                                  } else {
                                    console.log(
                                      "dataProcessingRlv",
                                      dataProcessingRlv
                                    );
                                    const mois = dateRlv.split("-")[1];
                                    const year = dateRlv.split("-")[0];
                                    setDataProcessingRlv((prevData) => {
                                      const newData = [...prevData];
                                      newData.push({
                                        date: `${dateOp}/${mois}`,
                                        year: year,
                                        operations: [
                                          {
                                            libille: libelle,
                                            account: trAccount,
                                            debit: debit,
                                            credit: credit,
                                            type: "initial",
                                          },
                                          {
                                            libille: "    ",
                                            account: souscompteRlvBq,
                                            debit: debit == 0 ? credit : 0,
                                            credit: credit == 0 ? debit : 0,
                                            type: "contrePartie",
                                          },
                                        ],
                                      });
                                      return newData;
                                    });
                                    console.log(
                                      "dataProcessingRlv",
                                      dataProcessingRlv
                                    );
                                  }
                                  window.$("#modalNewTrans").modal("hide");
                                  setLibelle("");
                                  setTrAccount("");
                                  setDebit(0);
                                  setCredit(0);
                                  setDateOp(0);
                                  setIsNewOp(false);
                                  setIndex();
                                }}
                              >
                                Ajouter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* fin add operattion modal*/}
                    </>
                  )
                ) : (
                  <div className="col-md-8">
                    <span>Traitement ...</span>
                    <div className="progress progress-md mb-3">
                      <div className="progress-bar progress-bar-indeterminate bg-blue-1"></div>
                    </div>
                  </div>
                )}
                {/* debut div de photo de relevee */}
                <div
                  className="col-md-4"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    borderLeft: "solid",
                    borderLeftWidth: "0.5px",
                    borderLeftColor: "darkgrey",
                  }}
                >
                  <h4>Relevé Bancaire</h4>
                  <figure>
                    <Zoom>
                      <img
                        id="previewRlv"
                        src={`${baseURL.replace("/api", "")}/draft/${
                          rlv?.file
                        }`}
                        width="90%"
                      />
                    </Zoom>
                  </figure>
                </div>
                {/* fin div de photo de relevee */}
              </div>
            </div>
            <div className="modal-footer">
              <div
                className="d-flex justify-content-between"
                style={{ width: "100%" }}
              >
                <div>
                  {stepRlv == 2 && (
                    <>
                      <button
                        type="button"
                        className="btn btn-info me-6"
                        onClick={() => {
                          setIsNewOp(true);
                          window.$("#modalNewTrans").modal("show");
                        }}
                        >
                        Ajouter une opération
                        </button>
                        <span
                        className="text-default"
                        style={{
                          fontSize: 21,
                          fontWeight: "bold",
                          marginRight: 70,
                        }}
                        >
                        Solde de ce Relevé Bancaire :{" "}
                        {(
                          parseFloat(soldeDepart) +
                          dataProcessingRlv
                          .reduce((total, data) => {
                            return (
                            total +
                            data.operations.reduce((sum, operation) => {
                              if (operation.type === "initial") {
                              return (
                                sum +
                                parseFloat(operation.debit) -
                                parseFloat(operation.credit)
                              );
                              }
                              return sum;
                            }, 0)
                            );
                          }, 0)
                        ).toFixed(2)}{" "}
                        {organisation?.currency?.code}{" "}
                        </span>
                      </>
                      )}
                    </div>
                    <div className="d-flex justify-content-between">
                      {stepRlv == 2 && (
                      <button
                        className="btn btn-default me-2"
                        onClick={() => {
                        setStepRlv(1);
                      }}
                    >
                      Précédent
                    </button>
                  )}
                  <button
                    className="btn btn-primary me-2"
                    onClick={async () => {
                      if (stepRlv === 1) {
                        if (dateRlv !== " " && souscompteRlvBq !== " ") {
                          setStepRlv(2);
                        } else {
                          toast.error("Veuillez remplir tous les champs", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                          });
                        }
                      } else {
                        const totalDebit = dataProcessingRlv.reduce(
                          (total, data) =>
                            total +
                            data.operations.reduce(
                              (sum, operation) =>
                                sum + parseFloat(operation.debit),
                              0
                            ),
                          0
                        );
                        const totalCredit = dataProcessingRlv.reduce(
                          (total, data) =>
                            total +
                            data.operations.reduce(
                              (sum, operation) =>
                                sum + parseFloat(operation.credit),
                              0
                            ),
                          0
                        );

                        if (totalDebit !== totalCredit) {
                          toast.error(
                            "Le total des débits et des crédits doit être égal",
                            {
                              position: "top-right",
                              autoClose: 5000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: false,
                              draggable: true,
                              progress: undefined,
                              theme: "colored",
                            }
                          );
                          return;
                        }

                        const allOperationsHaveAccount =
                          dataProcessingRlv.every((data) =>
                            data.operations.every(
                              (operation) => operation.account
                            )
                          );

                        if (!allOperationsHaveAccount) {
                          toast.error(
                            "Toutes les opérations doivent avoir un compte",
                            {
                              position: "top-right",
                              autoClose: 5000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: false,
                              draggable: true,
                              progress: undefined,
                              theme: "colored",
                            }
                          );
                          return;
                        }
                        //preparation des données pour l'envoi
                        //preparation des operations
                        const operations = dataProcessingRlv.flatMap((data) => {
                          const totalDebitOp = data.operations.reduce(
                            (sum, operation) =>
                              sum + parseFloat(operation.debit),
                            0
                          );
                          const totalCreditOp = data.operations.reduce(
                            (sum, operation) =>
                              sum + parseFloat(operation.credit),
                            0
                          );
                          const accountOp = souscompteRlvBq;
                          const [year, mois] = dateRlv.split("-");
                          const jour = data.date.split("/")[0];
                          console.log('jour',jour)
                          // const dateOp = `${jour}-${mois}-${year}`;
                          const dateOp = `${year}-${mois}-${jour}`;
                          //preparation des transactions
                          const transactions = data.operations.map((op) => {
                            return {
                              date: dateOp,
                              libelle: op.libille,
                              account_id: op.account,
                              debit: op.debit,
                              credit: op.credit,
                              type: op.type,
                            };
                          });

                          return {
                            date: dateOp,
                            total_debit: totalDebitOp,
                            total_credit: totalCreditOp,
                            
                            account: accountOp,
                            transactions: transactions,
                          };
                        });

                        const [year, mois] = dateRlv.split("-");
                        const dateR = `${mois}/${year}`;

                        const soldeR = parseFloat(soldeDepart) +
                         dataProcessingRlv.reduce(
                          (total, data) =>
                            total +
                            data.operations.reduce((sum, operation) => {
                              if (operation.type === "initial") {
                                return (
                                  sum +
                                  parseFloat(operation.debit) -
                                  parseFloat(operation.credit)
                                );
                              }
                              return sum  ;
                            }, 0),
                          0
                        );

                        const dataRlv = {
                          date: dateR,
                          solde: soldeR,
                          solde_depart:soldeDepart,
                          compte_bancaire: souscompteRlvBq,
                          organisation_id: organisation?.id,
                          draft_id: rlv.id,
                          operations: operations,
                        };
                        console.log(dataRlv);

                        try {
                          const response = await jwtInterceoptor.post(
                            "/data/rlvs/add",
                            dataRlv,
                            {
                              headers: {
                                "Content-Type": "application/json",
                              },
                            }
                          );

                          if (response.status === 200) {
                            toast.success(
                              "Le relevé bancaire a été ajouté avec succès",
                              {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: false,
                                draggable: true,
                                progress: undefined,
                                theme: "colored",
                              }
                            );
                            window.$("#fullscreenmodalRLV").modal("hide");
                            fetchRlv();
                            initDataRlv();
                          }
                        } catch (error) {
                          toast.error(
                            "Erreur lors de l'ajout du relevé bancaire",
                            {
                              position: "top-right",
                              autoClose: 5000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: false,
                              draggable: true,
                              progress: undefined,
                              theme: "colored",
                            }
                          );
                        }
                      }
                    }}
                  >
                    {stepRlv === 2 ? "Enregistrer" : "suivant"}
                  </button>

                  <button
                    className="btn btn-danger me-2"
                    onClick={() => {
                      window.$("#fullscreenmodalRLV").modal("hide");
                    }}
                  >
                    Fermer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="fullscreenmodal4ec"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-fullscreen" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <span
                  className="badge rounded-pill bg-warning badge-sm me-1 mb-1 mt-1"
                  style={{ fontSize: 20 }}
                >
                  écriture comptable
                </span>
              </h5>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="elt1">
                    <div>
                      <h1>
                        <strong>{t("Flux économique")}</strong>
                      </h1>
                    </div>
                    <div>
                      <table
                        className="table"
                        style={{ display: loading === 0 ? "block" : "none" }}
                      >
                        <thead className={"table-primary"}>
                          <tr>
                            <th scope="col">date de création</th>
                            <th scope="col">n° piéce</th>
                            <th scope="col">N° compte</th>
                            <th scope="col">sous compte</th>
                            <th scope="col">libellé écriture</th>
                            <th scope="col">débit</th>
                            <th scope="col">crédit</th>
                          </tr>
                        </thead>

                        <tbody>
                          {fluxEco.map((flux) => {
                            return (
                              <tr>
                                <th scope="col">{flux.date_creation}</th>
                                <th scope="col">{flux.no_piece}</th>
                                <th scope="col">
                                  <span>{flux.compte_fournisseur}</span>
                                  <br />
                                  {flux.compte_tva.map((tva) => {
                                    return (
                                      <span>
                                        {tva}
                                        <br />
                                      </span>
                                    );
                                  })}
                                  {flux.compte_compte_de_charge.map(
                                    (compte_de_charge) => {
                                      return (
                                        <span>
                                          {compte_de_charge}
                                          <br />
                                        </span>
                                      );
                                    }
                                  )}
                                </th>
                                <th scope="col">{flux.sous_compte}</th>
                                <th scope="col">{flux.libelle_fournisseur}</th>

                                <th scope="col">
                                  {flux.invoice_type === "vente"
                                    ? Number(flux.total_ttc).toFixed(2)
                                    : flux.total_ht_et_tva.map(
                                        (total_ht_et_tva, elt = 0) => {
                                          if (elt === 0) {
                                            elt++;
                                            return (
                                              <div>
                                                <br />
                                              </div>
                                            );
                                          }
                                          return (
                                            <div>
                                              {" "}
                                              {Number(total_ht_et_tva).toFixed(
                                                2
                                              )}{" "}
                                            </div>
                                          );
                                        }
                                      )}
                                </th>
                                <th scope="col">
                                  {flux.invoice_type === "vente"
                                    ? flux.total_ht_et_tva.map(
                                        (total_ht_et_tva, elt = 0) => {
                                          if (elt === 0) {
                                            elt++;
                                            return (
                                              <div>
                                                <br />
                                              </div>
                                            );
                                          }
                                          return (
                                            <div>
                                              {" "}
                                              {Number(total_ht_et_tva).toFixed(
                                                2
                                              )}{" "}
                                            </div>
                                          );
                                        }
                                      )
                                    : Number(flux.total_ttc).toFixed(2)}
                                </th>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <center>
                        <div
                          className="spinner-border text-primary me-2"
                          role="status"
                          style={{ display: loading === 1 ? "block" : "none" }}
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </center>
                    </div>
                  </div>
                  {isSauvgarded && (
                    <div className="addNewPiece">
                      <NewPiece
                        from={"ocr_ec"}
                        onSave={savePiece}
                        invIc={invoiceId}
                        invType={invoiceType}
                      />
                      <button
                        className="btn btn-default"
                        onClick={() => {
                          window.$("#fullscreenmodal4ec").modal("hide");
                        }}
                      >
                        Fermer
                      </button>
                    </div>
                  )}
                </div>
                <div
                  className="col-md-6"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    borderLeft: "solid",
                    borderLeftWidth: "0.5px",
                    borderLeftColor: "darkgrey",
                  }}
                >
                  <h4>Facture</h4>
                  <figure>
                    <Zoom>
                      <img
                        id="previewInvoice"
                        src={`${baseURL.replace("/api", "")}/draft/${
                          invoice?.file
                        }`}
                        width="90%"
                      />
                    </Zoom>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DraftInvoicesList;